import { CommonModule, TitleCasePipe } from '@angular/common';
import { HttpParams } from '@angular/common/http';
import { ApplicationRef, ChangeDetectorRef, Component, ComponentFactoryResolver, ComponentRef, CUSTOM_ELEMENTS_SCHEMA, ElementRef, EmbeddedViewRef, EventEmitter, Injector, Input, OnChanges, OnInit, Output, SimpleChanges, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { finalize, Observable, Subscription } from 'rxjs';
import { TruncatePipe } from 'src/app/pipe/TruncatePipe.pipe';
import { AppSettings } from 'src/app/services/AppSettings';
import { FormValidation } from 'src/app/services/FormValidation';
import { GigsumoConstants } from 'src/app/services/GigsumoConstants';
import { ApiService } from 'src/app/services/api.service';
import { candidateModel } from 'src/app/services/candidateModel';
import { JobService } from 'src/app/services/job.service';
import { JobModel } from 'src/app/services/jobModel';
import { UtilService } from 'src/app/services/util.service';
import { ContractCandidateService } from 'src/app/services/contract-candidate.service';
import Swal from 'sweetalert2';
import { CustomValidator } from '../../Helper/custom-validator';
import { PricePlanService } from '../../Price-subscritions/priceplanService';
import { CreditModelComponent } from '../../credit/credit-model/credit-model.component';
import { SubContractModalComponent } from '../../shared/sub-contract-modal/sub-contract-modal.component';
// import { CandidateCardComponent } from '../candidate-card/candidate-card.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { CommonSkeletonComponent } from '../../../skeleton/common-skeleton/common-skeleton.component';
import { ConnectionTemplateComponent } from '../../../templates/connection-template/connection-template.component';
import { TimezoneDatePipe } from '../../../timezone-date.pipe';
import { JobSubmitSkillfilterComponent } from '../../../widget/job-submit-skillfilter/job-submit-skillfilter.component';
import { MessageWidgetComponent } from '../../../widget/message-widget/message-widget.component';
// import { CandidatesPageComponent } from '../../candidate-module/candidates-page/candidates-page.component'; // Removed to break circular dependency
import { FlagComponent } from '../../flag/flag.component';
import { SearchData } from './../../../services/searchData';
import { SlidePanelService } from 'src/app/services/slide-panel.service';
import { MatchPercentageDetailsComponent } from '../../match-percentage-details/match-percentage-details.component';
import { CandidateDocumentsComponent } from '../../job-module/candidate-documents/candidate-documents.component';
import { DndDirective } from 'src/app/directives/dnd.directive';
import { NG_ICON_DIRECTIVES } from '@ng-icons/core';
import { CompactCountPipe } from '../../../pipe/compact-count.pipe';
import { isEyeIconMenu } from 'src/app/services/eye-icon-menu';

declare var $: any
@Component({
  selector: 'app-job-card',
  standalone: true,
  // Note: CandidatesPageComponent removed from imports to break circular dependency
  imports: [
    CompactCountPipe,
    BsDropdownModule,
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    TruncatePipe,
MessageWidgetComponent,
    InfiniteScrollModule,
    JobSubmitSkillfilterComponent,
    TimezoneDatePipe,
    FlagComponent,
    CommonSkeletonComponent,
    ConnectionTemplateComponent,
    TitleCasePipe,
    CandidateDocumentsComponent,
    MatchPercentageDetailsComponent,
    DndDirective
  ,
    NG_ICON_DIRECTIVES,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './job-card.component.html',
  styleUrls: ['./job-card.component.scss'],
  // providers: [CandidateCardComponent]
})
export class JobCardComponent extends FormValidation implements OnInit, OnChanges {

  /**
   * Report Job is hidden across the app (2026-09-25, owner request) until the
   * reporting flow is built out. The markup and the <app-flag> wiring are left
   * in place and simply not rendered, so switching this back to true is the only
   * change needed to bring it back.
   *
   * The same flag name is used in candidate-card, job (Jobs menu) and
   * candidates-page, so `grep -rn "reportEnabled"` finds every place to flip.
   */
  reportEnabled = false;
share() {
throw new Error('Method not implemented.');
}
saveJob() {
throw new Error('Method not implemented.');
}
reportJob() {
throw new Error('Method not implemented.');
}
  @Input() pageFrom:any;
  @Input() hideAiInsights = false;
  @Input() viewSize: any;
  @Input() passValues: any;
  @Input() From: "SUGGESTED_JOBS" | "FEATURED_JOB" | "JOBS_FROM_CONNECTION" | "JOBS_FROM_PLATFORM";
  @Input() feaJ;
  @Input() allowedJobCandidateCounts: number = 0;
  @Input() hideActions: boolean = false
  flag: boolean = false;
  userType: string = localStorage.getItem('userType');
  applyingJob: boolean = false
  checkedList: any = [];
  @Input() showStatus: any;
  @Input() showCheckBox: any;
  @Input() applyingCandidate: any;
  connectionStatus: string;
  counterpartsDetails: any;
  connectionRequestRef: BsModalRef;
  values: any;
  @Output() jobemit = new EventEmitter<any>()
  @Output() selectedJob: EventEmitter<any> = new EventEmitter()
  @Input() getJobsugg: any;
  @Input() isDowngraded: boolean = false;
  bsModalRef: BsModalRef;
  // fileDragdrop: any;
  resumeupload;
  Resurl = AppSettings.ServerUrl;
  fileSize = AppSettings.FILE_SIZE;
  candidateSupplyRef: BsModalRef;
  userId = localStorage.getItem('userId');
  @Input() jobsFoundStatus: any;

  // Dynamic component loading for CandidatesPageComponent (circular dependency fix)
  // Template reference to access after modal renders
  @ViewChild('candidateSupplyTemplate', { static: false }) candidateSupplyTemplate: TemplateRef<any>;
  private candidatesPageContainer: ViewContainerRef | null = null;
  private candidatesPageComponentRef: ComponentRef<any> | null = null;
  clickItemActive: any;
  @Input() JobData: any;
  @Input() selectedjobCount: any;
  @Input() indexInput: any;
  @Input() JobDataUser: any
  @Input() candidateData: any
  @Input() jobstatus: any
  @Input() isRoutingDisabled: boolean = false;
  @Input() showTimeline: boolean = false;
  @Input() currentCandidateId: string; // For showing candidate-specific details in slider
  businessId: string = localStorage.getItem('businessId') || '';
  seletedChatItem;
  messageData: any;
  messagemodelflag: any;
  @Output() suggcandidate = new EventEmitter()
  jobid
  load: Subscription;
  rtrformgrp: UntypedFormGroup;
  /** Isolated form group for the restored single-field "payrate" popup
   *  (pre-redesign design, see #payrateTemplate). Kept separate from
   *  `rtrformgrp` so the two-row "Submitted for / Offer for" RTR popup is
   *  completely unaffected. Wired only to the V3 job-invite ACCEPT. */
  payrategrp: UntypedFormGroup;
  url = AppSettings.photoUrl;
  GigsumoConstant = GigsumoConstants;
  rtrformModal: BsModalRef;
  rtrModalRef: BsModalRef;
  checkingApplyButton: boolean = false;
  tempFile: File;
  candidateStatus: string;
  dataPasstoSkillwidgets: Array<any> = [];
  termsCheck: any;
  rtrFormData: any;
  candidateFoundStatus: string;
  @Input() filterApplicantData: any;
  skillsExpanded: boolean = false; // Track skill expansion state for v2 design

  @Output() statusUpdated = new EventEmitter<any>();

  constructor(private fb: UntypedFormBuilder, private util: UtilService, private JobServicecolor: JobService,
    private searchData: SearchData, private a_route: ActivatedRoute, private router: Router, private pricePlan: PricePlanService,
    private modalService: BsModalService, private planService: PricePlanService,
    private api: ApiService,   private cdr: ChangeDetectorRef, private ngbModalService:NgbModal,
    private slidePanelService: SlidePanelService, private injector: Injector,
    private contractCandidateService: ContractCandidateService) {
    super();
    if (this.a_route.snapshot.url.length != 0 && this.a_route.snapshot.url[0].path !== undefined) {
      this.checkingApplyButton = this.a_route.snapshot.url[0].path === "cInvited" ? true : false;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.From) {
      this.From = changes.From.currentValue;
    }
  }

  triggerChange(jobId: string) { 
  } 

  getJobCssClasses(): any {

    // All status will enalbe for bussiness jobs page only
    const isBusinessJobsRoute = this.a_route.snapshot.url[0]?.path === 'business-jobs';

    // Normal disabled based on the status for all other pages
    return {
      'disabled': !isBusinessJobsRoute && (!this.JobData?.availability || this.JobData?.status !== 'ACTIVE'),
      'featured-background': this.JobData?.isFeatured === true
    };
  }

  getActiveUrgencyDays(job: any): number | null {
    if (!job?.isFeatured) return null;

    const now = new Date();

    if (job?.featuredConsumptions?.length > 0) {
      const lastConsumption = job.featuredConsumptions[job.featuredConsumptions.length - 1];

      // Use toDate directly from backend (most accurate)
      if (lastConsumption.toDate) {
        const toDate = new Date(lastConsumption.toDate);
        const diffMs = toDate.getTime() - now.getTime();

        // If upgrade has expired, return null (don't show badge)
        if (diffMs <= 0) return null;

        // Convert to days, rounding up (any remaining time counts as 1 day)
        const days = Math.ceil(diffMs / (1000 * 60 * 60 * 24));
        return days > 0 ? days : 1;
      }

      // Fallback: use dayCount if toDate not available
      const dayCount = lastConsumption.dayCount || 1;
      return dayCount;
    } else if (job?.featuredUpdatedOn) {
      const featuredDate = new Date(job.featuredUpdatedOn);
      const urgencyEndDate = new Date(featuredDate.getTime() + (2 * 24 * 60 * 60 * 1000));
      const diffMs = urgencyEndDate.getTime() - now.getTime();
      const days = Math.ceil(diffMs / (1000 * 60 * 60 * 24));
      return days > 0 ? days : 1;
    }

    return 1;
  }


  
  @Output() jobapp_to_newjob_to_atvity = new EventEmitter<any>();
  selectCheckbox(value, jobVal) {
    const checked = event.target;
    if (value == true) {
      let data: Partial<{ jobId: string, eachJob: boolean }> = {}
      data.jobId = jobVal;
      this.jobemit.emit({ value: jobVal, flag: "true" });
    } else if (value == false) {
      this.jobemit.emit({ value: jobVal, flag: "false" });
    }
    jobVal.isSelected = value;
    this.jobapp_to_newjob_to_atvity.emit({ ...jobVal, checked: checked });

  }
  userTypeMap: { [key: string]: string } = {
    'FREELANCE_RECRUITER': 'Freelance Recruiter',
    'RECRUITER': 'Recruiter',
    'JOB_SEEKER': 'Job Seeker',
    'MANAGEMENT_TALENT_ACQUISITION': 'Manager',
    'MANAGEMENT TALENT ACQUISITION': 'Manager',
    'BENCH_RECRUITER': 'Bench Recruiter'
  };





  tempcandidateval: Array<any>;
  count = 0
  ngOnInit(): void {
    // Locked 2026-06-08 — two-row payrate model (parity with candidate-card).
    this.rtrformgrp = this.fb.group({
      submittedToRate: [{ value: null, disabled: true }],
      submittedRateType: [{ value: null, disabled: true }],
      offerRate: [null, Validators.compose([Validators.required, CustomValidator.validDecimal(), CustomValidator.checkWhiteSpace()])],
      offerRateType: [null, Validators.required],
      termsandcondition: [null, Validators.requiredTrue],
      country: null
    })
    // Restored pre-redesign single-field model (Rate + Pay Type). Mirrors the
    // old `rtrformgrp` from commit 8df93a5b9^. No "submitted ceiling" cap —
    // validators are exactly the original required + decimal + whitespace.
    this.payrategrp = this.fb.group({
      targetrate: [null, Validators.compose([Validators.required, CustomValidator.validDecimal(), CustomValidator.checkWhiteSpace()])],
      termsandcondition: [null, Validators.requiredTrue],
      country: null,
      RtrpayType: [null, Validators.required]
    })
    if (this.selectedjobCount == undefined || this.selectedjobCount == null) {
      this.selectedjobCount = 1;
    }

    this.prepareTimelinePayload();

    // Initialize timeline data for medium / row-design / jc-v3-row views.
    // jc-v3-row used to render a dateless 6-dot pipe driven by
    // JobData.currentStatus; it now reads `timelineDataGrouped` (built by
    // `prepareTimeline`) so the Activity Map shows the per-stage date,
    // matching the wireframe and parity with candidate-card row-design.
    if ((this.viewSize === 'medium' || this.viewSize == 'row-design' || this.viewSize === 'jc-v3-row') && this.showTimeline == true) {
      setTimeout(() => {
        console.log('Timeline init - viewSize:', this.viewSize, 'candidateId:', this.candidateData?.candidateId, 'jobId:', this.JobData?.jobId);
        // this.loadTimelineData();
        this.prepareTimeline();
      }, 500);
    }

    if(this.pageFrom != 'suggestedJobs'){
      // this.getSavedRequiredDocuments('init');
    }

    this.JobData.showAllSkills = false;
    
  }
  FormData: any;
  tempstatus
  statusCall: string;
  showResumeUpload: boolean;
  @ViewChild("RTRtemplate") rtrformTemplate;
  async updatestatus(status, value, template: TemplateRef<any>) {

    if (status === "ACCEPTED") {

      const userData = await this.pricePlan.UPDATE_USERDETAILS("ACTIVE_INTERACTIONS");
      let { membershipType } = userData;
      if (userData.isExpired) {
        let availablePoints = null;
        let actualPoints = null;
        let utilizedPoints = null;
        let promotional = null;
        userData.userDetail.userPlanAndBenefits.benefitsUsages.forEach(ele => {
          if (ele.benefitKey == 'ACTIVE_INTERACTIONS') {
            availablePoints = ele.available
            actualPoints = ele.actual
            utilizedPoints = ele.utilized
            promotional = ele.promotional
          }
        })
        let popupType: "PAY" | "LIMIT" | "UPGRADE" = "PAY";

        if (['Starter', 'Growth', 'ScaleX'].includes(membershipType)) {
          popupType = "LIMIT";
        }
        this.planService.expiredPopup("ACTIVE_INTERACTIONS", popupType, null, null, null, null, availablePoints, actualPoints, utilizedPoints, promotional);

        return;
      }
      else {
        this.afterValidatingPlan(status, value, template);
      }
    }
    else {
      this.afterValidatingPlan(status, value, template);
    }

  }

  getInitials(fullname: string): string {
    return this.JobServicecolor.getInitials(fullname);
  }

  getColor(fullname: string): string {
    return this.JobServicecolor.getColor(fullname);
  }
  getFullNameTextColor(fullname: string): string {
    return this.JobServicecolor.getFullnameTextColor(fullname);
  }

  // ── Job Owner (recruiter / manager who posted the job) ──────────────
  // Drives the V3 `jc-v3-row` owner column on the candidate-page tabs
  // (Job Invites / Applied / Marketplace Jobs). Every candidate-page tab
  // passes the poster as `[JobDataUser]="item.user"`; fall back to
  // `JobData.user` for any caller that only sets the nested form.
  get jobOwner(): any {
    return this.JobDataUser || this.JobData?.user || null;
  }

  // Normalizes a profile photo path — passes through full http(s) URLs,
  // otherwise prefixes the base photo URL (same behaviour as the V2 cards
  // and the candidate-card owner avatar).
  getPhotoUrl(photo: string): string {
    if (!photo) return '';
    if (photo.startsWith('http://') || photo.startsWith('https://')) return photo;
    return this.url + photo;
  }

  // Pretty userType label for the owner role line (BENCH_RECRUITER →
  // "Bench Recruiter"), reusing the existing `userTypeMap`.
  formatUserType(userType: string): string {
    if (!userType) return '';
    return this.userTypeMap[userType]
      || userType.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
  }

  // Get current organization name from work experience
  getCurrentOrganizationName(jobData: any): string {
    if (!jobData?.user?.workExperience || !Array.isArray(jobData.user.workExperience)) {
      return this.JobDataUser?.companyName || '';
    }

    const currentOrg = jobData.user.workExperience.find(
      (exp: any) => exp.currentOrganization === true
    );

    return currentOrg?.organisationName || this.JobDataUser?.companyName || '';
  }

  // Job-status label mirror of candidate-card-table-view's
  // `getCandidateStatusLabel` — returns the user-facing word for the
  // four states the row pill renders (ACTIVE/DRAFTED/INACTIVE/BLOCKED),
  // empty string otherwise so the badge hides on unknown values.
  getJobStatusLabel(status: string): string {
    if (!status) return '';
    const map: Record<string, string> = {
      'ACTIVE': 'Active',
      'DRAFTED': 'Draft',
      'INACTIVE': 'Inactive',
      'BLOCKED': 'Blocked',
      // Job lifecycle statuses the owner list (job.component jc-v3 pills)
      // also labels — 'ON HOLD' comes from the backend with a space
      // (GigsumoConstants.ON_HOLD). getStageStyle() already carries their
      // colors, so only the label was missing here.
      'FILLED': 'Filled',
      'ON HOLD': 'On Hold',
      'CLOSED': 'Closed'
    };
    return map[status] || '';
  }

  // Mirrors `APPLICANT_STATUS_COLOR` in FormValidation.ts (used by
  // candidate-card.component via inherited getStyle()), so the V3 stage
  // pill on the candidate-side job card matches the V2 card pill exactly.
  getStageStyle(status: string): { background: string; color: string } {
    if (!status) status = 'APPLIED';
    const normalized = status.toUpperCase();

    const statusColorMap: Record<string, { background: string; color: string }> = {
      'APPLIED': { background: '#e0f5f1', color: '#2d7a6c' },
      'JOB-APPLIED': { background: '#e0f5f1', color: '#2d7a6c' },
      'ACCEPTED': { background: '#e0f5f1', color: '#2d7a6c' },
      'INITIATED': { background: '#e0f5f1', color: '#2d7a6c' },
      'ACTIVE': { background: '#e0f5f1', color: '#2d7a6c' },
      'FILLED': { background: '#e0f5f1', color: '#2d7a6c' },
      'INTERVIEW-ACCEPTED': { background: '#e0f5f1', color: '#2d7a6c' },
      'OFFER-ACCEPTED': { background: '#e0f5f1', color: '#2d7a6c' },
      'SHORTLISTED': { background: '#d9eefb', color: '#1d6fa7' },
      'INTERVIEW SCHEDULED': { background: '#d9eefb', color: '#1d6fa7' },
      'CANDIDATE-SHORTLISTED': { background: '#daf3f3', color: '#1d7576' },
      'INTERVIEW-SCHEDULED': { background: '#dffbdf', color: '#1a8d19' },
      'SELECTED': { background: '#d8f5d8', color: '#0a5f0b' },
      'CANDIDATE-SELECTED': { background: '#d8f5d8', color: '#0a5f0b' },
      'OFFERED': { background: '#f3f9d3', color: '#748500' },
      'ONBOARDED': { background: '#edffd2', color: '#5c8c0d' },
      'PREONBOARDED': { background: '#d6f5fa', color: '#0d7182' },
      'PRE-ONBOARDED': { background: '#d0f9ef', color: '#039171' },
      'REJECTED': { background: '#ffe5e5', color: '#d40000' },
      'PROFILE-REJECTED': { background: '#ffe5e5', color: '#d40000' },
      'INTERVIEW REJECTED': { background: '#ffe5e5', color: '#d40000' },
      'INTERVIEW-REJECTED': { background: '#ffe5e5', color: '#d40000' },
      'INTERVIEW-FAILED': { background: '#ffe5e5', color: '#d40000' },
      'OFFER DECLINED': { background: '#ffe5e5', color: '#d40000' },
      'OFFER-DECLINED': { background: '#ffe5e5', color: '#d40000' },
      'WITHDRAW': { background: '#ffe5e5', color: '#d40000' },
      'CANDIDATE-WITHDRAWN': { background: '#ffe5e5', color: '#d40000' },
      'CANDIDATE BACKOUT': { background: '#ffe5e5', color: '#d40000' },
      'INACTIVE': { background: '#ffe5e5', color: '#d40000' },
      'BLOCKED': { background: '#ffe5e5', color: '#d40000' },
      'UNAVAILABLE': { background: '#ffe5e5', color: '#d40000' },
      'DRAFTED': { background: '#ffe5e5', color: '#d40000' },
      'OFFER WITHDRAWN': { background: '#ffe0e0', color: '#a00100' },
      'OFFER-WITHDRAWN': { background: '#ffe0e0', color: '#a00100' },
      'RESUME-PENDING': { background: '#fff0d6', color: '#b37400' },
      'ON HOLD': { background: '#ffeae5', color: '#cc6a51' },
      'CLOSED': { background: '#eeeeee', color: '#5a5a5a' },
    };

    return statusColorMap[normalized] || { background: '#e0f5f1', color: '#2d7a6c' };
  }

  // Get stage label
  getStageLabel(status: string): string {
    if (!status) return 'Applied';

    const labelMap = {
      'JOB-APPLIED': 'Applied',
      'CANDIDATE-SHORTLISTED': 'Shortlisted',
      'INTERVIEW-SCHEDULED': 'Interview Scheduled',
      'INTERVIEW-ACCEPTED': 'Interview Accepted',
      'CANDIDATE-SELECTED': 'Selected',
      'OFFERED': 'Offered',
      'OFFER-ACCEPTED': 'Offer Accepted',
      'ONBOARDED': 'Onboarded',
      'PRE-ONBOARDED': 'Pre-Onboarded',
      'REJECTED': 'Rejected',
      'INTERVIEW-REJECTED': 'Interview Rejected',
      'OFFER-DECLINED': 'Offer Declined',
      'OFFER-WITHDRAWN': 'Offer Withdrawn',
      'INITIATED': 'Invited',
      // Accepting an invite = applying — V2 parity (candidate-card.component
      // .html:417) and the job-side Candidates Invited pill
      // (candidate-card-table-view.getInvitedStatusLabel) both read "Applied".
      'ACCEPTED': 'Applied',
      'INTETEREST_SHOWN': 'Invited'
    };

    // Unmapped statuses (L1/L2/L3-INTERVIEW etc.) must still read as
    // 'L1 Interview' — the old replace(/-/g,' ') fallback kept them ALL CAPS.
    return labelMap[status] || this.formatStatusLabel(status);
  }

  downloadResume(candidateId, userId, createdBy, FileId, fileName?) {
    const endpoint = `candidates/resumeDownload/${candidateId}/${userId}/${createdBy}/${FileId}`;
    this.api.queryBlob(endpoint).subscribe(res => {
      const blob = new Blob([res]);
      // Strip backend's `<uuid>_` prefix so the saved file keeps its real
      // extension. Default to `.pdf` to avoid the OS opening it as text.
      const raw = (fileName || '').toString().trim();
      const uuidPrefix = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}_/;
      const cleaned = (uuidPrefix.test(raw) ? raw.replace(uuidPrefix, '').trim() : raw) || 'resume.pdf';
      this.downloadFile(blob, cleaned);
    });
  }

  negativeStauses = ['REJECTED','PROFILE-REJECTED','INTERVIEW-REJECTED','INTERVIEW-FAILED','OFFER-DECLINED','CANDIDATE-WITHDRAWN','OFFER-WITHDRAWN'];

  validateNegativeStatus(datas: any,value:any){
    console.warn('status to update : ', datas.itemId);
    // validate negative status for confirmation
    if (this.negativeStauses.includes(datas.itemId)) {
      
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: 'btn btn-success',
          cancelButton: 'btn btn-danger'
        },
        buttonsStyling: false
      });
  
      swalWithBootstrapButtons.fire({
        title: 'Are you sure you want to '+ this.prepareMessage(datas.itemId) + '?',
        html: `Once you ${this.prepareMessage(datas.itemId)}, you will no longer be considered for this job.<br>
        <p>This action cannot be undone.</p>`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'Cancel',
        reverseButtons: true
      }).then(result => {
        if(result.isConfirmed){
          this.updatestatuswithdraw(datas,value);
        }
      });
    }else {
      this.updatestatuswithdraw(datas,value);
    }
  }

  prepareMessage(sts:any):string {
    if(sts == 'INTERVIEW-REJECTED'){
      return 'reject interview';
    }else if(sts == 'CANDIDATE-WITHDRAWN'){
      return 'withdraw';
    }else if(sts == 'OFFER-DECLINED'){
      return 'decline offer'
    }
  }

  updatestatuswithdraw(datas, value) {

    this.util.startLoader();
    var data: any = {};
    data.jobId = value.jobId;
    data.candidateId = this.candidateData.candidateId;
    data.jobPostedBy = value.jobPostedBy;
    data.currentStatus = datas.itemId;
    data.candidateName = this.candidateData.firstName + " " + this.candidateData.lastName;
    data.jobTitle = value.jobTitle;
    data.createdByUserName = value.postedByUserName;
    // data.organisationName = localStorage.getItem('currentOrganization');
    data.email = value.user.username;
    // this.JobData.currentStatus = datas.itemId;
    this.jobupdatestatus(data);
  }

  async jobupdatestatus(data) {
    // ----- TEMPORARY free-plan gate (reduces data issues; full free-plan handling is a separate
    // effort). OFFER-ACCEPTED -> candidate owner accepting -> check the CANDIDATE OWNER's plan.
    // CANDIDATE-SELECTED / OFFERED / PRE-ONBOARDED / ONBOARDED -> job owner advancing -> check the
    // acting (logged-in) business's plan. Only code 10004 (free/null plan) blocks; any other code
    // or error proceeds, so Business-plan (paid) users are never blocked. -----
    {
      const planStatus = (data.currentStatus || '').toUpperCase();
      const ownerPlanStatuses = ['OFFER-ACCEPTED'];
      const actorPlanStatuses = ['CANDIDATE-SELECTED', 'OFFERED', 'PRE-ONBOARDED', 'ONBOARDED'];
      if (ownerPlanStatuses.includes(planStatus) || actorPlanStatuses.includes(planStatus)) {
        this.util.startLoader();
        try {
          let planRes: any;
          if (ownerPlanStatuses.includes(planStatus)) {
            planRes = await this.contractCandidateService.validateBusinessPlan(data.candidateId, '').toPromise();
          } else {
            const userId = localStorage.getItem('userId') || '';
            let actorBusinessId = '';
            try {
              const roleRes: any = await this.api.query(`business/findUserRoleInBusiness/${userId}`).toPromise();
              actorBusinessId = roleRes?.data?.businessData?.businessId || '';
            } catch (e) { actorBusinessId = ''; }
            planRes = await this.contractCandidateService.validateBusinessPlan('', actorBusinessId).toPromise();
          }
          if (planRes?.code === '10004') {
            this.util.stopLoader();
            Swal.fire({
              icon: 'warning',
              title: 'Business Plan Required',
              html: "You can't proceed with the next process on the Free plan. Please purchase a Business Plan to continue.",
              confirmButtonText: 'OK'
            });
            return;
          }
        } catch (e) { /* don't hard-block on a plan-check error */ }
        this.util.stopLoader();
      }
    }

    // Gate only PRE-ONBOARDED / ONBOARDED through /validate-b2b-connection.
    // Locked 2026-06-10 — OFFER-ACCEPTED removed from this list. The Job Applied page
    // (/newcandidates) is the candidate-owner's surface: when they Accept Offer for
    // their candidate, that's just the candidate confirming the role — it does NOT
    // require a live B2B link between candidate-owner and job-owner. Previously this
    // call returned 10002 ("No B2B connection found between customer and supplier")
    // and blocked the candidate-owner with a "Go to Business Contacts" popup. The
    // B2B link is enforced LATER — at PRE-ONBOARDED / ONBOARDED (contract goes live)
    // and at /assign (Initiate Contract wizard). Mirrors the same fix applied earlier
    // to candidate-job-details VALIDATE_STAGES.
    // Earlier transitions (INTERVIEW-*, OFFERED, OFFER-ACCEPTED, OFFER-DECLINED,
    // CANDIDATE-WITHDRAWN, etc.) skip the call entirely. Backend returns:
    //  - 00000 → proceed
    //  - 10002 → no B2B connection (popup with "Go to Business Contacts" CTA)
    //  - 10003 → no B2B and viewer is not SUPERADMIN (role popup, no CTA)
    //  - 10005 → Corp-to-Corp JOB_SEEKER missing current org
    const b2bGatedStatuses = ['PRE-ONBOARDED', 'ONBOARDED'];
    const needsB2bCheck = b2bGatedStatuses.includes((data.currentStatus || '').toUpperCase());

    this.util.startLoader();

    if (needsB2bCheck) {
      const userId = localStorage.getItem('userId') || '';
      let viewerBusinessId = '';
      try {
        const roleRes: any = await this.api.query(`business/findUserRoleInBusiness/${userId}`).toPromise();
        viewerBusinessId = roleRes?.data?.businessData?.businessId || '';
      } catch (e) {
        viewerBusinessId = '';
      }

      try {
        const b2bRes: any = await this.contractCandidateService
          .validateB2bConnection(viewerBusinessId, data.jobId, data.candidateId, data.currentStatus)
          .toPromise();
        if (b2bRes?.code === '10005') {
          this.util.stopLoader();
          Swal.fire({
            icon: 'warning',
            title: 'Organization Required',
            html: b2bRes.message || 'Corp-to-Corp candidates must have an active organization.',
            confirmButtonText: 'OK',
            showCancelButton: false
          });
          return;
        } else if (b2bRes?.code === '10002' || b2bRes?.code === '10003') {
          this.util.stopLoader();
          const result = await this.contractCandidateService.showNoB2bPopup(b2bRes.code, b2bRes.message);
          if (result.isConfirmed && b2bRes.code === '10002') {
            // OFFER-ACCEPT 10002 is hit by the supplier-side viewer (the candidate's
            // business). Backend returns customerBusinessId = job owner. Land on the
            // Business Contacts page with queryParams so the Add Business form opens
            // pre-filled and BusinessType is restricted to Client / Client/Supplier.
            const customerId = b2bRes?.data?.customerBusinessId || '';
            const customerName = b2bRes?.data?.customerBusinessName || '';
            this.router.navigate(['/user-management/businessContacts'], {
              queryParams: {
                customerBusinessId: customerId,
                customerBusinessName: customerName
              }
            });
          }
          return;
        } else if (b2bRes?.code === '99996') {
          // Mandatory-document gate. This whole block only runs for
          // PRE-ONBOARDED / ONBOARDED, which is exactly when the backend's
          // document check fires — so 99996 is an expected outcome here, not a
          // generic validation error. Shared wording with candidate-card.
          this.util.stopLoader();
          await this.contractCandidateService.showMandatoryDocumentPopup();
          return;
        } else if (b2bRes?.code !== '00000') {
          this.util.stopLoader();
          Swal.fire({
            icon: 'error',
            title: 'Validation Failed',
            text: b2bRes?.message || 'Unable to proceed with this status change.'
          });
          return;
        }
        // 00000 → proceed with the status update below (loader remains started).
      } catch (e) {
        // Validation call failed — don't block the user (backend still has its own
        // authorization guard on /updatejobAppliedStatus). Continue with the update.
      }
    }

    try {
      const res = await this.api.create("candidates/updatejobAppliedStatus", data).toPromise();
      this.util.stopLoader();
      if (res.code === "00000") {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Status successfully Updated.",
          showConfirmButton: false,
          timer: 2000,
        });
        data.eachCandidate = true;
        data.isSelected = true;
        this.searchData.setJobID(data);
        this.JobData.currentStatus = data.currentStatus;
        //get the activitydate in api response by monisha
        const appliedCandidate = res.data.jobData.appliedBy.find(candidate => candidate.userId === data.candidateId);
        data.activityDate = appliedCandidate ? appliedCandidate.date : null;
        this.jobapp_to_newjob_to_atvity.emit(data);
        this.statusUpdated.emit();
      } else if (res.code == "99998") {
        Swal.fire({
          position: "center",
          icon: "info",
          title: "Job application status updated already..!",
          showConfirmButton: true,
          allowEscapeKey: false,
          allowOutsideClick: false,
        }).then((result) => {
          if (result.isConfirmed) {
            this.JobServicecolor.confirmResult();
          }
        });
      }
    } catch (err) {
      this.util.stopLoader();

    }
  }

  getFilterValue(key: string, content: string = "JOB_APPLIED") {
    if (this.filterApplicantData) {
      const arrs: Array<any> = content === "JOB_APPLIED" ? [...this.filterApplicantData.JOB_APPLICATION_SUPPLIER_ACTIONS.listItems] :
        [...this.filterApplicantData.JOB_INVITATION_SUPPLIER_ACTIONS.listItems];

      if (arrs) {
        const find = arrs.find(c => c.itemId === key);
        // Fall back to the normalized raw status so unmapped stages
        // (L1/L2/L3 INTERVIEW) never leave the pill blank.
        return find ? find.value : this.formatStatusLabel(key);
      }
    }
  }

  filterApplicant(data, content: string = "JOB_APPLIED") {

    if (this.filterApplicantData) {


      const arrs: Array<any> = content === "JOB_APPLIED" ? [...this.filterApplicantData.JOB_APPLICATION_SUPPLIER_ACTIONS.listItems] :
        [...this.filterApplicantData.JOB_INVITATION_SUPPLIER_ACTIONS.listItems];
      const order = arrs.find(_x => _x.itemId === data)!.order;

      const finalData = arrs.reduce((acc: Array<any>, current, index, arr) => {

        const find = acc.find(_d => _d.itemId === current.itemId);
        const next = arr.indexOf(current) + 1;

        if (find === undefined) {

          const nextData = arr[next];

          if (nextData && (current.item === undefined || current.item === null) && data === current.itemId) {
            if (nextData.item != undefined || nextData.item != null) {
              acc.push(...arr.filter(c => c.order === order + 1));
              return acc;
            }
          }

          if ((current.order === undefined || current.order === null) && current.item != undefined) {
            acc.push(current);
          }

        }

        return acc;

      }, []);



      return finalData;
    }

  }


  /**
   * Locked 2026-06-08 — tier resolver for supplier-side RTR modal.
   *   1. Viewer is the supplier; look for tier where supplierBusinessId == viewer
   *      (that's the tier the buyer extended to this supplier — its toPayRate is
   *      the ceiling THIS supplier is allowed to bid within).
   *   2. Fallback: tier where customerBusinessId == viewer (if supplier later
   *      becomes a sub-publisher to its own downstream).
   *   3. Final fallback: first tier (the job-owner's tier).
   */
  private resolveViewerTier(viewerBizId: string, job: any): any {
    const tiers = job?.tierPayRates || [];
    if (!tiers.length || !viewerBizId) return null;
    const upstream = tiers.find((t: any) => t?.supplierBusinessId
        && t.supplierBusinessId.toLowerCase() === viewerBizId.toLowerCase());
    if (upstream) return upstream;
    const owned = tiers.find((t: any) => t?.customerBusinessId
        && t.customerBusinessId.toLowerCase() === viewerBizId.toLowerCase());
    if (owned) return owned;
    // Locked 2026-06-10 — first-tier fallback removed. Callers now fall through
    // to value.targetRateTo + payType (already wired at the call site) instead of
    // silently using the job-owner's tier for every viewer that lacks a matching
    // row in tierPayRates.
    return null;
  }

  afterValidatingPlan(status, value, template: TemplateRef<any>) {
    if (value.targetRateTo != null) {
      // Locked 2026-06-08 — two-row patch. Submitted-for ceiling resolved from
      // the viewer's tier on the job; Offer-for editable, defaults to the
      // candidate's existing targetRateTo so the supplier can adjust + submit.
      const viewerBizId = localStorage.getItem('myBusinessId')
          || localStorage.getItem('businessId') || '';
      const tier = this.resolveViewerTier(viewerBizId, value);
      const submittedToRate = tier?.toPayRate ?? value.targetRateTo ?? null;
      const submittedRateType = tier?.rateType ?? (value.payType || 'Hourly');
      // Locked 2026-06-10 — Offer For initial value mirrors Submitted For. Offer
      // For stays editable; Submitted For is read-only. Previously Offer For
      // pre-filled from the candidate's existing targetRateTo, which often
      // diverged from the supplier's ceiling — now both rows share the same
      // starting value and the supplier adjusts Offer For from there.
      this.rtrformgrp.patchValue({
        submittedToRate,
        submittedRateType,
        offerRate: submittedToRate,
        offerRateType: submittedRateType,
        country: value.country != null ? value.country : "",
        termsandcondition: null
      });
      const offerCtrl = this.rtrformgrp.get('offerRate');
      if (offerCtrl) {
        const validators = [Validators.required, CustomValidator.validDecimal(), CustomValidator.checkWhiteSpace()];
        if (typeof submittedToRate === 'number' && submittedToRate > 0) {
          validators.push(Validators.max(submittedToRate));
        }
        offerCtrl.setValidators(validators);
        offerCtrl.updateValueAndValidity({ emitEvent: false });
      }
    }
    this.rtrformgrp.get('termsandcondition').markAsUntouched();
    if (status === 'ACCEPTED') {
      this.statusCall = 'ACCEPTED';
      let resumes: Array<any> = this.candidateData.resumes;
      if ((resumes != null && resumes.length > 0) || value.resumeUpdated) {

        if (resumes != null && resumes != undefined) this.showResumeUpload = resumes.length > 0 ? false : true;

        if (value.resumeUpdate) this.showResumeUpload = false;

        let ngbModalOptions: NgbModalOptions = { backdrop: 'static', keyboard: false };
        this.tempdata = value;
        this.tempstatus = status;
        this.tempcanddata = this.candidateData;
        this.resumeupload = null;
        this.fileDragdrop = null;
        this.resumeflag = false;
        this.rtrModalRef = this.modalService.show(template, ngbModalOptions);

      }
      else if (!value.resumeUpdated || resumes === null || resumes === undefined) {
        this.showResumeUpload = value.resumeUpdated ? false : true;


        let ngbModalOptions: NgbModalOptions = { backdrop: 'static', keyboard: false };
        this.tempdata = value;
        this.tempstatus = status;
        this.tempcanddata = this.candidateData;
        this.resumeupload = null;
        this.fileDragdrop = null;
        this.resumeflag = false;
        this.rtrModalRef = this.modalService.show(template, ngbModalOptions);
      }
    }
    else if (!value.resumeUpdated || status === 'REJECTED') {
      this.showResumeUpload = value.resumeUpdated ? false : true;
      this.tempdata = value;
      this.statusCall = 'REJECTED';
      this.tempstatus = status;
      this.tempcanddata = this.candidateData;
      this.resumeupload = null;
      this.fileDragdrop = null;
      this.resumeflag = false;
      this.submit();
    }
  }
  async openMessagecheckInteraction(seletedItem, connectionTemplate?: TemplateRef<any>) {
    // Universal first-interaction: skip the ACTIVE_INTERACTIONS gate (no
    // findUserPlanBenefits / findPlans) when this job's interaction was already
    // consumed — an existing chat OR the current user already applied to it
    // (backend `alreadyConsumed` via job.appliedBy). This makes "Applied" skip the
    // gate while "Marketplace Job" (no prior apply) still gates. Fails safe.
    // Owner's rule (2026-09-09): one credit is consumed only when a chat is
    // first initiated, so every menu follows this exist-first order.
    if (await this.planService.isInteractionAlreadyConsumed(seletedItem?.jobId, 'JOB')) {
      this.chatuser(seletedItem);
      return;
    }
    try {
      this.util.startLoader();
      const userData = await this.planService.UPDATE_USERDETAILS("ACTIVE_INTERACTIONS");
      let { userDetail, isExpired, membershipType } = userData;
      let availablePoints = null;
      let actualPoints = null;
      let utilizedPoints = null;
      let promotional = null;
      if (userDetail && userDetail.userPlanAndBenefits && userDetail.userPlanAndBenefits.benefitsUsages) {
        userDetail.userPlanAndBenefits.benefitsUsages.forEach(ele => {
          if (ele.benefitKey == 'ACTIVE_INTERACTIONS') {
            availablePoints = ele.available;
            actualPoints = ele.actual;
            utilizedPoints = ele.utilized;
            promotional = ele.promotional;
          }
        });
      } else {
        this.util.startLoader();
        this.chatuser(seletedItem);

        return;
      }

      if (isExpired) {
        let popupType: "PAY" | "LIMIT" | "UPGRADE" = "PAY";

        if (['Starter', 'Growth', 'ScaleX'].includes(membershipType)) {
          popupType = "LIMIT";
        }

        this.planService.expiredPopup("ACTIVE_INTERACTIONS", popupType, null, null, null, null, availablePoints, actualPoints, utilizedPoints, promotional);

      } else {
        this.util.startLoader();
        this.chatuser(seletedItem);

      }
    } catch (error) {
    } finally {
      setTimeout(() => {
        this.util.stopLoader();
      }, 1500);
    }

  }

  afterValidatingApplyPlan(values) {
    this.tempApplyValue = values;
    var profiledata: any = {}
    profiledata.userId = localStorage.getItem('userId')
    profiledata.userType = localStorage.getItem('userType')
    this.api.create('user/profileDetails', profiledata).subscribe(res => {
      // let element: any = {};
      values.clientType = values.user.clientType;
      values.userType = values.user.userType;
      if (values.clientType == undefined && values.userType == undefined) {
        values.clientType = res.data.userData.clientType;
        values.userType = res.data.userData.userType;
      }
      let datas: any = {};
      let routedata: any;
      var temparr = [];
      var datacheck = [{ 'userId': localStorage.getItem('userId') }]
      datas.jobPostedBy = localStorage.getItem('userId');
      datas.jobId = values.jobId;
      datas.appliedBy = datacheck;
      values.feaJ = this.feaJ;
      values.jobfilter = true;
      values.targetRate = this.rtrformgrp.value.offerRate;
      values.filterTitle = 'Select';
      this.router.navigate(["newcandidates"], { queryParams: values });
    });
  }
  isClicked: boolean = false;
  tempApplyValue: any
  jobData: any;
  apply(values: any, connectionTemplate?: TemplateRef<any>, candidateSupplyTemplate?: TemplateRef<any>) {
    if (this.isClicked) {
      return;
    }

    console.log('apply called, isClicked:', this.isClicked);
    this.util.startLoader();
    this.isClicked = true;
    this.jobData = values;
    if (values.isFeatured == true) {
      this.proceedToApply(values, candidateSupplyTemplate);
      this.util.stopLoader();
    } else if (!values.isFeatured) {
      if (values.connectionStatus === 'CONNECTED') {
        this.proceedToApply(values, candidateSupplyTemplate);
      } else if (values.connectionStatus !== 'CONNECTED') {
        this.proceedToApply(values, candidateSupplyTemplate);
        // to be used later
        // this.openConnectionTemplate(values.connectionStatus, values, connectionTemplate);
      }
    }
    setTimeout(() => {
      this.isClicked = false;
    }, 5000);
  }

  async proceedToApply(values, candidateSupplyTemplate) {
    this.util.startLoader();
    const userData = await this.pricePlan.UPDATE_USERDETAILS("ACTIVE_INTERACTIONS");
    let { membershipType } = userData;
    if (userData.isExpired && this.userType != "JOB_SEEKER") {
      this.util.stopLoader();
      let availablePoints = null;
      let actualPoints = null;
      let utilizedPoints = null;
      let promotional = null;
      userData.userDetail.userPlanAndBenefits.benefitsUsages.forEach(ele => {
        if (ele.benefitKey == 'ACTIVE_INTERACTIONS') {
          availablePoints = ele.available
          actualPoints = ele.actual
          utilizedPoints = ele.utilized
          promotional = ele.promotional
        }
      })
      let popupType: "PAY" | "LIMIT" | "UPGRADE" = "PAY";

      if (['Starter', 'Growth', 'ScaleX'].includes(membershipType)) {
        popupType = "LIMIT";
      }
      this.planService.expiredPopup("ACTIVE_INTERACTIONS", popupType, null, null, null, null, availablePoints, actualPoints, utilizedPoints, promotional);

      // Eye-icon menu only (see isEyeIconMenu): release the Apply lock here, on the
      // no-slots path. apply() otherwise held it for a blind 5 seconds, so closing
      // the popup and clicking Apply again inside that window did nothing. The
      // success path deliberately keeps that timer: myCandidatesForApply() opens its
      // modal asynchronously, AFTER this method returns, so releasing earlier there
      // would let a quick double click open the candidate picker twice.
      // Every other screen that renders this card is deliberately left as it was.
      if (isEyeIconMenu(this.router)) {
        this.isClicked = false;
      }
      return;
    }
    this.myCandidatesForApply(values.jobId, candidateSupplyTemplate);
    // values.clientType = values.user.clientType;
    this.util.startLoader();
    values.userType = values.user.userType;
    let datas: any = {};
    var datacheck = [{ 'userId': localStorage.getItem('userId') }]
    datas.jobPostedBy = localStorage.getItem('userId');
    datas.jobId = values.jobId;
    datas.appliedBy = datacheck;
    values.jobfilter = true;
    values.filterTitle = 'Select';
    values.fromBusinessPage = false
    values.jobDescription = "";
    // const config: ModalOptions = { class: 'modal-lg', backdrop: 'static', keyboard: false };
    // this.router.navigate(["newcandidates"], { queryParams: values });
    // this.searchData.setHighlighter('newcandidates')
    // this.candidateSupplyRef = this.modalService.show(candidateSupplyTemplate, config);


  }


  closeCandidateSupplyModal() {
    
    // Reset all selected candidates
    if (this.applyResponse && this.applyResponse.length > 0) {
      this.applyResponse.forEach(element => {
        element.isSelected = false;
      });
    }

    // Clear the selected candidates list shown in the form (Selected field)
    this.dataPasstoSkillwidgets = [];

    // Also clear resume data and form data
    this.resumeData = [];
    this.rtrFormData = null;
    this.termsCheck = null;

    this.modalService.hide(1);
    this.isClicked = false;
  }

  removeUserfromTag(data) {
    if (data === "REFRESH") {
      this.jobemit.emit(data);
    }
    else {
      // Clear the selected candidates list shown in the form (Selected field)
      this.dataPasstoSkillwidgets = [];
      
      this.applyResponse.forEach(element => {
        if (element.candidateId == data.candidateId) {
          element.isSelected = false;
        }
      });

      this.dataPasstoSkillwidgets.forEach(element => {
        if (element.candidateId == data.candidateId) {
          element.isSelected = false;
        }
      });
    }

  }

  applyResponse: any = [];
  myCandidatesForApply(jobId: string, candidateSupplyTemplate: any) {
    const responseData: any = {
      "source": {
        "all": false,
        "myCandidates": true,
        "allPlatFormCandidates": false,
        "teamCandidates": false,
        "benchNetworkCandidates": false,
        "freeLancerNetworkCandidates": false,
        "mtaNetworkCandidates": false,
        "jobSeekerNetworkCandidates": false,
        "featured": false,
        "suggestedCandidates": false
      },
      "workType": {
        "all": false,
        "remoteWork": false,
        "relocationRequired": false,
        "workFromHome": false
      },
      "jobId": jobId,
      "workAuthorization": [],
      "engagementType": [],
      "availableIn": [],
      "status": [],
      "searchAfterKey": null,
      "city": null,
      "state": null,
      "country": null,
      "zipCode": null,
      "submissionFilters": [],
      "postedFrom": null,
      "postedTo": null,
      "limit": 10,
      "userId": this.userId,
      "searchContent": ""
    }

    this.api.create('candidates/filter', responseData).subscribe(res => {
      this.util.stopLoader();
      if (res.code === GigsumoConstants.SUCESSCODE) {
        this.applyResponse = res.data.candidateList;
        if (this.applyResponse.length === 0) {
          this.candidateFoundStatus = "Couldn't find any Candidates for the applied filters.";
        }
        const config: ModalOptions = { class: 'modal-lg', backdrop: 'static', keyboard: false };
        this.candidateSupplyRef = this.modalService.show(candidateSupplyTemplate, config);

        // Load CandidatesPageComponent dynamically after modal is rendered
        setTimeout(() => {
          this.cdr.detectChanges();
          this.loadCandidatesPageComponent();
        }, 150);
      }
    });

  }

  resumeData: any = []
  getchildData(data: any) {
    this.termsCheck = data.terms;
    if (data.resumes) {
      this.resumeData = data.resumes
    }
    if (data.value != null) {
      this.dataPasstoSkillwidgets = data.value;
      this.rtrFormData = data.formData;
    } else {
      this.dataPasstoSkillwidgets = [];
    }
  }

  openConnectionTemplate(connectionStatus, values, connectionTempate?: TemplateRef<any>) {
    this.connectionStatus = connectionStatus;
    this.values = values;
    const initialState: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false,
      size: 'sm',
    };
    this.api.query("user/" + this.values.jobPostedBy).subscribe(res => {
      if (res.code == '00000') {
        this.counterpartsDetails = res;
        this.connectionRequestRef = this.modalService.show(connectionTempate, initialState);
      }
    })
  }

  getUserDetails(): Observable<any> {
    return this.api.query("user/" + this.values.jobPostedBy);
  }

  checkConnectionStatus(values): Observable<any> {

    const apiURL = 'user/checkConnectionStatus';
    const params = new HttpParams()
      .set('userId', this.userId)
      .set('connnectorId', values.jobPostedBy);

    const urlWithParams = `${apiURL}?${params.toString()}`;
    return this.api.query(urlWithParams);
  }




  get rtrFormControls() {
    return this.rtrformgrp.controls
  }

  like(values: any) {
    if (values.isProcessingLike) return;
    if (values.jobPostedBy != localStorage.getItem("userId")) {
      let datas: any = {};
      datas.jobId = values.jobId;
      datas.userId = localStorage.getItem("userId");

      const likeStatus = values.isLiked === true ? "UNLIKE" : "LIKE";

      values.isProcessingLike = true;
      this.util.startLoader();
      datas.likeStatus = likeStatus;

      this.api.updatePut("jobs/updateJobLiked", datas).subscribe((res) => {
        if (res.code == "00000") {
          this.util.stopLoader();
          this.JobData.likesCount = res.data.jobData.likesCount;
          this.JobData.isLiked = res.data.jobData.isLiked;
        }
        values.isProcessingLike = false;
      }, err => {
        values.isProcessingLike = false;
        this.util.stopLoader();
      });
    } else {
      this.goTo(values, 'jobs-liked');
    }
  }
  isInteger(event) {
    // Read the caret from the input that actually fired the event. The old
    // `document.getElementById('myText')` referenced an element that doesn't
    // exist in these popups, so `ctl.selectionStart` threw on every keypress —
    // Angular's listener wrapper treats a thrown handler as `return false`,
    // which calls preventDefault(), making the field impossible to type in.
    const input = event.target as HTMLInputElement;
    const startPos = input ? input.selectionStart : null;
    // Prevent a leading zero (original intent), but allow everything else.
    if (startPos === 0 && String.fromCharCode(event.which || event.keyCode || 0) === '0') {
      return false;
    }
    return true;
  }

  goTo(values, param) {
    if (values.jobPostedBy == this.userId && values.jobPostedBy != undefined) {
      if (param == 'job-applicants' && values.appliedCount > 0) {
        this.router.navigate(['newjobs'], { queryParams: { jobId: values.jobId, tabName: 'job-applicants', From: this.From } });
      } else if (param == 'views' && values.viewedByCount != undefined) {
        this.router.navigate(['newjobs'], { queryParams: { jobId: values.jobId, tabName: 'jobs-viewed', From: this.From } });
      }
      else if (param == 'jobs-liked' && values.status != 'ON HOLD') {
        this.router.navigate(['newjobs'], { queryParams: { jobId: values.jobId, tabName: 'jobs-liked', From: this.From } });
      }
      else if (param == "candidates-invited") {
        this.router.navigate(['newjobs'], { queryParams: { jobId: values.jobId, tabName: 'candidates-invited', From: this.From } });
      }
    }
    else if (values.jobPostedBy != this.userId) {
      if (param == 'jobs-applied' && values.appliedCount > 0 && values.status != 'ON HOLD') {
        this.router.navigate(['newjobs'], { queryParams: { jobId: values.jobId, tabName: 'job-details', From: this.From } });
      } else if (param == 'views' && values.status != 'ON HOLD') {
        this.router.navigate(['newjobs'], { queryParams: { jobId: values.jobId, tabName: 'job-details', From: this.From } });
      }
      // else if (param == 'job-applicants' && values.appliedCount > 0) {
      //   this.router.navigate(['newjobs'], { queryParams: { jobId: values.jobId, tabName: 'job-applicants', From: this.From } });
      // }
      else if (param == 'candidate-applied' && values.candidatesApplied && values.candidatesApplied.length > 0) {
        this.router.navigate(['newjobs'], { queryParams: { jobId: values.jobId, tabName: 'candidate-applied', From: this.From } });
      }

    }

  }

  isExcludedStatus(status: string, content: string = "JOB_APPLIED"): boolean {
    if (this.filterApplicantData) {

      const find = content === "JOB_APPLIED" ? (this.filterApplicantData.JOB_APPLICATION_BLOCKING_ACTIONS.listItems &&
        this.filterApplicantData.JOB_APPLICATION_BLOCKING_ACTIONS.listItems.find(x => x.itemId === status)) :
        (this.filterApplicantData.JOB_INVITATION_BLOCKED_ACTIONS.listItems &&
          this.filterApplicantData.JOB_INVITATION_BLOCKED_ACTIONS.listItems.find(x => x.itemId === status));
      return find ? true : false;
    }
  }



  openModalWithComponent() {
    const initialState: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false,
      size: "open"
    };
    this.modalService.show(CreditModelComponent, { initialState });
  }

  openSubContractModal(job: JobModel): void {
    this.modalService.show(SubContractModalComponent, {
      initialState: {
        jobDetails: job,
        businessId: localStorage.getItem('businessId') || '',
        userId: localStorage.getItem('userId') || ''
      },
      class: 'modal-md',
      backdrop: 'static',
      keyboard: false
    });
  }

  open(values: any) {

    if (values.status != "BLOCKED") {
      if (values.clientType == null) {
        values.clientType = values.user.clientType
      }
      if (values.user != null) {
        values.clientType = values.user.clientType;
      }
      let data: any = {}
      data.jobPostedBy = values.jobPostedBy;
      data.jobId = values.jobId;
      if (values.isViewed != null && values.isViewed == true && values.jobPostedBy != this.userId) {
        this.router.navigate(['newjobs'], { queryParams: { jobId: values.jobId, tabName: 'job-details', From: this.From } });
      } else if (values.jobPostedBy == this.userId || localStorage.getItem('userType') == 'JOB_SEEKER') {
        this.router.navigate(['newjobs'], { queryParams: { jobId: values.jobId, tabName: 'job-details', From: this.From } });
      } else if (values.isViewed) {
        this.router.navigate(['newjobs'], { queryParams: { jobId: values.jobId, tabName: 'job-details', From: this.From } });
      } else {
        this.router.navigate(['newjobs'], { queryParams: { jobId: values.jobId, tabName: 'job-details', From: this.From } });
      }
    }
  }

  view(jobData) {
    this.router.navigate(['newjobs'], { queryParams: { jobId: jobData.jobId, tabName: 'job-details', From: this.From } });
  }

  /** Row-level eye icon → open slider on the Job Details tab. */
  openJobInSlidePanel(jobData: any): void {
    this.slidePanelService.openJobDetail(jobData, this.currentCandidateId, {
      variant: 'v3',
      initialTab: 'profile',
      // Candidate context (Applied/Invites tabs pass it) so the slider can
      // show the "Submitted for" rate for this candidate on this job.
      candidateData: this.candidateData,
      // Job Center (viewSize 'customer-row-design') tags itself as
      // 'job-center' so the slider can gate the header Chat on an
      // established connection — Job-Center-only. Other surfaces keep
      // their existing pageFrom (AI ranking groups) and unchanged Chat.
      pageFrom: this.viewSize === 'customer-row-design'
        ? 'job-center'
        : ((this.pageFrom === 'suggestedJobs') ? 'suggestedJobs'
            : ((this.pageFrom === 'jobsInvited') ? 'jobsInvited' : 'jobsApplied')),
      hideAiInsights: this.hideAiInsights,
      // Single-scroll drawer only on the SuperAdmin Job Center
      // (viewSize 'customer-row-design'). Other job-card surfaces keep
      // the original whole-panel scroll.
      compactScroll: this.viewSize === 'customer-row-design'
    });
  }

  /** Match-badge click → open slider on the AI Insights tab.
   *  `pageFrom` maps: suggestedJobs → 'suggestedJobs' (SUGGESTED_JOB group),
   *  anything else (Applied / Marketplace Jobs applicants) → 'jobsApplied'
   *  (APPLICANT_JOB group). */
  openMatch(jobData: any, ev?: Event): void {
    if (ev) { ev.stopPropagation(); ev.preventDefault(); }
    this.slidePanelService.openJobDetail(jobData, this.currentCandidateId, {
      variant: 'v3',
      initialTab: 'ai',
      candidateData: this.candidateData,
      pageFrom: this.viewSize === 'customer-row-design'
        ? 'job-center'
        : ((this.pageFrom === 'suggestedJobs') ? 'suggestedJobs'
            : ((this.pageFrom === 'jobsInvited') ? 'jobsInvited' : 'jobsApplied')),
      hideAiInsights: this.hideAiInsights,
      compactScroll: this.viewSize === 'customer-row-design'
    });
  }

  ngAfterViewInit(): void {
  }


  chatuser(seletedItem, connectionTemplate?: TemplateRef<any>) {

    this.messagemodelflag = false;


    this.jobData = seletedItem;
    if (seletedItem.isFeatured == true || (seletedItem.jobPostedBy == this.userId)) {

      this.openMessage(seletedItem);
    } else if (!seletedItem.isFeatured) {
      if (seletedItem.connectionStatus === 'CONNECTED') {
        this.openMessage(seletedItem);

      } else if (seletedItem.connectionStatus !== 'CONNECTED') {
        this.openMessage(seletedItem);

      }
    }


  }

  openMessage(seletedItem) {
    if (seletedItem.jobPostedBy == this.userId) {
      seletedItem.owner = true;
    } else {
      seletedItem.owner = false;
    }

    setTimeout(() => {
      seletedItem.userId = seletedItem.jobPostedBy;
      this.seletedChatItem = seletedItem;
      this.messageData = [];
      this.messagemodelflag = true;
      seletedItem.groupType = "JOB";
      seletedItem.messageType = "JOB";
      seletedItem.id = seletedItem.jobId;
      this.messageData = seletedItem;
    }, 1000);
  }

  closeMessage(event) {
    this.messagemodelflag = false;
  }

  onDownload() {
    const file: File = this.tempFile;
    this.downloadFile(new Blob([file]), file.name);
  }

  downloadFile(blob: Blob, fileName: string): void {
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    document.body.append(link);
    link.click();
    link.remove();
    setTimeout(() => URL.revokeObjectURL(link.href), 0);
  }


  onFileDropped(files: any) {
    console.log('Files dropped:', files);
    if (files && files.length > 0) {
      this.prepareFilesList(files);
    }
  }

  fileBrowseHandler(files: FileList) {
    console.log('Files browsed:', files);
    if (files && files.length > 0) {
      this.prepareFilesList(files);
    }
  }
  fileDragdrop: any = null;
  @ViewChild('fileDropRef') fileDropRef: ElementRef;
  @ViewChild('payrateFileDropRef') payrateFileDropRef: ElementRef;
  prepareFilesList(files: Array<File> | FileList) {
    // Ensure we have a valid file
    if (!files || files.length === 0) {
      console.log('No files to process');
      return;
    }
  
    const file = files[0]; // Get the first file
    console.log('Processing file:', file);
  
    // Check file size
    if (file.size > this.fileSize) {
      Swal.fire("", `${this.IMAGE_ERROR}`, "info");
      if (this.fileDropRef && this.fileDropRef.nativeElement) {
        this.fileDropRef.nativeElement.value = '';
      }
      return;
    }
  
    // Define acceptable formats
    const acceptableFormats = [
      'application/pdf',
      'application/docx',
      'application/doc',
      'text/plain',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'application/msword'
    ];
  
    console.log('File type:', file.type);
  
    // Check if file type is acceptable
    if (acceptableFormats.includes(file.type)) {
      // Create a more robust file object with properties your template can display
      this.fileDragdrop = {
        file: file,
        fileName: file.name,
        fileSize: this.formatBytes(file.size),
        fileType: file.type
      };
      console.log('File accepted:', this.fileDragdrop);
      this.resumeupload = file;
      
      // Update candidateData.resumeAttached flag when file is uploaded
      // if (this.candidateData) {
      //   this.candidateData.resumeAttached = true;
      // }
      
      // If you have resumeflag variable that's used elsewhere
      this.resumeflag = true;
      
      // Trigger change detection if needed
      if (this.cdr && !this.cdr['destroyed']) {
        this.cdr.detectChanges();
      }
    } else {
      console.log('Invalid file format');
      this.fileDragdrop = null;
      this.resumeupload = null;
      Swal.fire({
        icon: "info",
        title: "Please upload a valid format.",
        showDenyButton: false,
        timer: 3000,
      });
    }
  }
  removeFiles() {
    this.fileDragdrop = null;
    this.resumeupload = null;
    
    // Reset resumeAttached flag when file is removed
    if (this.candidateData) {
      this.candidateData.resumeAttached = false;
    }
    
    // If you have resumeflag variable that's used elsewhere
    this.resumeflag = false;
    
    if (this.fileDropRef && this.fileDropRef.nativeElement) {
      this.fileDropRef.nativeElement.value = '';
    }

    // The payrate (RTR) flow uses a separate #payrateFileDropRef input. Clear
    // it too — without this, removing the file leaves the input's value intact,
    // so re-selecting the SAME file fires no `change` event and upload fails.
    if (this.payrateFileDropRef && this.payrateFileDropRef.nativeElement) {
      this.payrateFileDropRef.nativeElement.value = '';
    }

    // Trigger change detection if needed
    if (this.cdr && !this.cdr['destroyed']) {
      this.cdr.detectChanges();
    }
  }

  // Helper function to format bytes
  formatBytes(bytes: number, decimals: number = 2): string {
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }


  tempdata: JobModel;
  tempcanddata: candidateModel;
  resumeflag = false;
  submitRTR: boolean = false;

  checkAttached() {
    // First check if candidateData already has resume attached
    if (this.candidateData && this.candidateData.resumeAttached === true) {
      return false; // Already has resume, so return false (no need to attach)
    }
    
    // Check if resumeflag is true (if you're using this variable)
    if (this.resumeflag === true) {
      return false;
    }
    
    // Then check if a new resume has been uploaded
    if (this.resumeupload === "" || 
        this.resumeupload === undefined || 
        this.resumeupload === null) {
      return true; // No resume, so return true (needs attachment)
    } else {
      return false; // Has new resume, so return false (no need to attach)
    }
  }

  submitted: boolean = false
  submit() {
    this.rtrformgrp.markAllAsTouched();
    var data: any = {}
    this.submitRTR = true;


    if (!this.candidateData.resumeAttached && this.checkAttached() && this.statusCall !== 'REJECTED') {
      Swal.fire({
        icon: "info",
        title: "Please upload Resume...",
        showDenyButton: false,
        timer: 3000,
      })
      return
    }




    if ((this.rtrformgrp.valid && this.rtrformgrp.value.termsandcondition) || this.statusCall === 'REJECTED') {
      this.util.startLoader();
      data.jobId = this.tempdata.jobId;
      data.organisationName = this.tempdata.jobPostedBehalfOf;
      data.postedByUserName = this.tempdata.postedByUserName
      data.jobTitle = this.tempdata.jobTitle;
      data.jobPostedBy = this.tempdata.jobPostedBy;
      data.candidateId = this.tempcanddata.candidateId;
      data.currentStatus = this.tempstatus;
      data.targetRateFortheCandidate = this.rtrformgrp.value.offerRate;
      data.payTypeFortheCandidate = this.rtrformgrp.value.offerRateType;
      // data.primaryResume=true;

      this.FormData = new FormData();
      this.FormData.append("job", new Blob([JSON.stringify(data)], { type: "application/json" }));
      this.FormData.append("file", this.resumeupload);

      this.api.create('jobs/updateInterestShownStatus', this.FormData).subscribe(res => {
        this.util.stopLoader();
        if (res.code == '00000') {
          data.isSelected = true;
          if (this.tempstatus === 'ACCEPTED') {
            this.showResumeUpload = false
          }
          const appliedinvites = (res.data.candidateData?.jobsApplied ?? []).find(jobs => jobs.userId === data.jobId);
          data.activityDate = appliedinvites ? appliedinvites.date : null;
          // Patch the local candidate's jobsApplied with the fresh array from the
          // apply response, so the job slider's "Submitted for" (which reads
          // candidateData.jobsApplied matched by jobId) shows the just-submitted
          // rate immediately — no separate refresh call or list reload needed.
          if (this.candidateData && Array.isArray(res.data.candidateData?.jobsApplied)) {
            this.candidateData.jobsApplied = res.data.candidateData.jobsApplied;
          }
          this.jobapp_to_newjob_to_atvity.emit(data);
          this.candidateData.resumeAttached = true;
          this.resumeflag = true;
          this.JobData.currentStatus = this.tempstatus;
          if (this.statusCall === 'ACCEPTED') this.hide();
          Swal.fire({
            icon: "success",
            title: `Invitation ${this.statusCall === 'ACCEPTED' ? 'Accepted' : 'Rejected'} Sucessfully`,
            showConfirmButton: false,
            timer: 2000,
          });
          let datas: Partial<{ jobId: string, eachJob: boolean }> = {}
          datas.jobId = this.tempdata.jobId;
          datas.eachJob = true;
          this.searchData.setJobID(datas);

          this.resumeupload = null;
          this.fileDragdrop = null;
          this.submitted = true;
        }
      }, err => {
        this.util.stopLoader();
      });
    }
  }

  hide() {
    this.rtrModalRef.hide();
    this.rtrformgrp.reset();
    this.submitRTR = false;

    // Reset file upload state when canceling
    this.resumeupload = null;
    this.fileDragdrop = null;
    this.resumeflag = false;

    if (this.fileDropRef?.nativeElement) {
      this.fileDropRef.nativeElement.value = '';
    }

    // Trigger change detection
    if (this.cdr && !this.cdr['destroyed']) {
      this.cdr.detectChanges();
    }
  }

  // ───────────────────────────────────────────────────────────────────────
  // Restored single-field "payrate" popup (#payrateTemplate) — pre-redesign
  // design wired ONLY to the V3 job-invite ACCEPT (jb_dpDown_v3_1). Mirrors
  // the original updatestatus / afterValidatingPlan / submit / hide flow but
  // reads `payrategrp` (targetrate + RtrpayType) instead of the two-row
  // `rtrformgrp`, so the two-row RTR popup and its logic stay untouched.
  // ───────────────────────────────────────────────────────────────────────
  get payrateFormControls() {
    return this.payrategrp.controls;
  }

  async updatestatusPayrate(status, value, template: TemplateRef<any>) {
    if (status === "ACCEPTED") {
      const userData = await this.pricePlan.UPDATE_USERDETAILS("ACTIVE_INTERACTIONS");
      let { membershipType } = userData;
      if (userData.isExpired) {
        let availablePoints = null;
        let actualPoints = null;
        let utilizedPoints = null;
        let promotional = null;
        userData.userDetail.userPlanAndBenefits.benefitsUsages.forEach(ele => {
          if (ele.benefitKey == 'ACTIVE_INTERACTIONS') {
            availablePoints = ele.available
            actualPoints = ele.actual
            utilizedPoints = ele.utilized
            promotional = ele.promotional
          }
        })
        let popupType: "PAY" | "LIMIT" | "UPGRADE" = "PAY";
        if (['Starter', 'Growth', 'ScaleX'].includes(membershipType)) {
          popupType = "LIMIT";
        }
        this.planService.expiredPopup("ACTIVE_INTERACTIONS", popupType, null, null, null, null, availablePoints, actualPoints, utilizedPoints, promotional);
        return;
      } else {
        this.afterValidatingPlanPayrate(status, value, template);
      }
    } else {
      this.afterValidatingPlanPayrate(status, value, template);
    }
  }

  afterValidatingPlanPayrate(status, value, template: TemplateRef<any>) {
    // if (value.targetRateTo != null) {
    //   // Old single-field patch — pre-fill Rate from the candidate's existing
    //   // targetRateTo and Pay Type from the job. No ceiling cap.
    //   this.payrategrp.patchValue({
    //     targetrate: value.targetRateTo,
    //     RtrpayType: value.payType != null ? value.payType : "Hourly",
    //     country: value.country != null ? value.country : "",
    //     termsandcondition: null
    //   });
    // }
    this.payrategrp.patchValue({
    RtrpayType: value.payType != null ? value.payType : "Hourly",
    country: value.country != null ? value.country : "",
    termsandcondition: null
  });
    if (value.targetRateTo != null) {
    this.payrategrp.patchValue({
      targetrate: value.targetRateTo
    });
  }
    this.payrategrp.get('termsandcondition').markAsUntouched();
    if (status === 'ACCEPTED') {
      this.statusCall = 'ACCEPTED';
      let resumes: Array<any> = this.candidateData.resumes;
      if ((resumes != null && resumes.length > 0) || value.resumeUpdated) {
        if (resumes != null && resumes != undefined) this.showResumeUpload = resumes.length > 0 ? false : true;
        if (value.resumeUpdate) this.showResumeUpload = false;
        let ngbModalOptions: NgbModalOptions = { backdrop: 'static', keyboard: false };
        this.tempdata = value;
        this.tempstatus = status;
        this.tempcanddata = this.candidateData;
        this.resumeupload = null;
        this.fileDragdrop = null;
        this.resumeflag = false;
        this.rtrModalRef = this.modalService.show(template, ngbModalOptions);
      } else if (!value.resumeUpdated || resumes === null || resumes === undefined) {
        this.showResumeUpload = value.resumeUpdated ? false : true;
        let ngbModalOptions: NgbModalOptions = { backdrop: 'static', keyboard: false };
        this.tempdata = value;
        this.tempstatus = status;
        this.tempcanddata = this.candidateData;
        this.resumeupload = null;
        this.fileDragdrop = null;
        this.resumeflag = false;
        this.rtrModalRef = this.modalService.show(template, ngbModalOptions);
      }
    } else if (!value.resumeUpdated || status === 'REJECTED') {
      this.showResumeUpload = value.resumeUpdated ? false : true;
      this.tempdata = value;
      this.statusCall = 'REJECTED';
      this.tempstatus = status;
      this.tempcanddata = this.candidateData;
      this.resumeupload = null;
      this.fileDragdrop = null;
      this.resumeflag = false;
      this.submitPayrate();
    }
  }

  submitPayrate() {
    this.payrategrp.markAllAsTouched();
    var data: any = {}
    this.submitRTR = true;

    if (!this.candidateData.resumeAttached && this.checkAttached() && this.statusCall !== 'REJECTED') {
      Swal.fire({
        icon: "info",
        title: "Please upload Resume...",
        showDenyButton: false,
        timer: 3000,
      })
      return
    }

    if ((this.payrategrp.valid && this.payrategrp.value.termsandcondition) || this.statusCall === 'REJECTED') {
      this.util.startLoader();
      data.jobId = this.tempdata.jobId;
      data.organisationName = this.tempdata.jobPostedBehalfOf;
      data.postedByUserName = this.tempdata.postedByUserName
      data.jobTitle = this.tempdata.jobTitle;
      data.jobPostedBy = this.tempdata.jobPostedBy;
      data.candidateId = this.tempcanddata.candidateId;
      data.currentStatus = this.tempstatus;
      data.targetRateFortheCandidate = this.payrategrp.value.targetrate;
      data.payTypeFortheCandidate = this.payrategrp.value.RtrpayType;

      this.FormData = new FormData();
      this.FormData.append("job", new Blob([JSON.stringify(data)], { type: "application/json" }));
      this.FormData.append("file", this.resumeupload);

      this.api.create('jobs/updateInterestShownStatus', this.FormData).subscribe(res => {
        this.util.stopLoader();
        if (res.code == '00000') {
          data.isSelected = true;
          if (this.tempstatus === 'ACCEPTED') {
            this.showResumeUpload = false
          }
          const appliedinvites = (res.data.candidateData?.jobsApplied ?? []).find(jobs => jobs.userId === data.jobId);
          data.activityDate = appliedinvites ? appliedinvites.date : null;
          // Patch the local candidate's jobsApplied with the fresh array from the
          // apply response, so the job slider's "Submitted for" (which reads
          // candidateData.jobsApplied matched by jobId) shows the just-submitted
          // rate immediately — no separate refresh call or list reload needed.
          if (this.candidateData && Array.isArray(res.data.candidateData?.jobsApplied)) {
            this.candidateData.jobsApplied = res.data.candidateData.jobsApplied;
          }
          this.jobapp_to_newjob_to_atvity.emit(data);
          this.candidateData.resumeAttached = true;
          this.resumeflag = true;
          this.JobData.currentStatus = this.tempstatus;
          if (this.statusCall === 'ACCEPTED') this.hidePayrate();
          Swal.fire({
            icon: "success",
            title: `Invitation ${this.statusCall === 'ACCEPTED' ? 'Accepted' : 'Rejected'} Sucessfully`,
            showConfirmButton: false,
            timer: 2000,
          });
          let datas: Partial<{ jobId: string, eachJob: boolean }> = {}
          datas.jobId = this.tempdata.jobId;
          datas.eachJob = true;
          this.searchData.setJobID(datas);

          this.resumeupload = null;
          this.fileDragdrop = null;
          this.submitted = true;
        }
      }, err => {
        this.util.stopLoader();
      });
    }
  }

  hidePayrate() {
    this.rtrModalRef.hide();
    this.payrategrp.reset();
    this.submitRTR = false;

    // Reset file upload state when canceling
    this.resumeupload = null;
    this.fileDragdrop = null;
    this.resumeflag = false;

    if (this.fileDropRef?.nativeElement) {
      this.fileDropRef.nativeElement.value = '';
    }

    if (this.cdr && !this.cdr['destroyed']) {
      this.cdr.detectChanges();
    }
  }

  // Timeline properties (copied from job-activity-widget)
  timelineIsLoading = false;
  jeas: any = [];
  payload: any = {};
  displayingdata: any;
  mergedTimelineData: any[] = [];
  
  // Timeline filter data (from timeline component)
  filterStatusData: Array<any>;
  jobApplicationListValues: any[] = []
  jobApplicationFutureListValues: any[] = []
  blockingListValues: any[] = []
  activityEnded: boolean = false;
  
  // Timeline methods - copied from job-activity-widget
  loadTimelineData() {
    if (!this.candidateData?.candidateId || !this.JobData?.jobId) {
      console.log('Timeline: Missing candidateId or jobId');
      this.jeas = [];
      return;
    }
    
    this.prepareTimelinePayload();
    this.fetchJobActivities();
  }
  
  prepareTimelinePayload() {
    // Initialize payload exactly like job-activity-widget
    this.payload = {
      entityId: this.candidateData?.candidateId, // Use candidateId as entityId
      entityType: "CANDIDATE",
      limit: 20,
      searchAfterKey: null,
      activityOn: this.JobData?.jobId, // jobId goes in activityOn
      parentActivity: "JOB_APPLICATION,CANDIDATE_INVITATION"
    };
    
    // Set owner flag like in job-activity-widget
    if (this.candidateData?.createdBy == this.userId) {
      this.payload.owner = true;
    } else {
      this.payload.owner = false;
    }
    
    console.log('Timeline payload:', this.payload);
  }
  
  fetchJobActivities() {
    this.timelineIsLoading = true;
    this.api.create("jobs/findTimeLines", this.payload).subscribe(res => {
      console.log('Timeline API response:', res);
      if (res && res.code === "00000" && res.data) {
        this.displayingdata = res.data;
        this.handleTimelineResponse(res.data);
      } else {
        this.timelineIsLoading = false;
        this.jeas = [];
        this.mergedTimelineData = [];
      }
    }, err => {
      console.error('Timeline API error:', err);
      this.timelineIsLoading = false;
      this.jeas = [];
      this.mergedTimelineData = [];
    });
  }
  
  handleTimelineResponse(data) {
    if (data && data.timeLines) {
      this.updateJobActivities(data.timeLines);
      // After updating jeas, get the filter data and process timeline for display
      this.getJobAppliedFilter();
    } else {
      this.timelineIsLoading = false;
      this.jeas = [];
      this.mergedTimelineData = [];
    }
  }
  
  updateJobActivities(timeLines) {
    this.jeas = [];
    timeLines.forEach(ele => {
      if (ele.entityType == "CANDIDATE") {
        ele.entityId = ele.candidateData?.candidateReferenceId
      } else {
        ele.entityId = ele.jobData?.jobReferenceId
      }
      this.jeas.push(ele);
    });
    
    // Remove duplicates
    this.jeas = this.jeas.filter((obj, pos, arr) => {
      return arr.map(mapObj => mapObj.activityId).indexOf(obj.activityId) === pos;
    });
    
    console.log('Timeline events processed:', this.jeas);
  }
  
  // Timeline filter processing (copied from timeline component)
  getJobAppliedFilter() {
    this.api.create('listvalue/findbyList', { domain: "TIMELINE_ACTIVITY_VALUES,JOB_APPLICATION_ACTIVITY,BLOCKING_ACTIVITY_LIST" }).subscribe(res => {
      const sorted: Array<any> = res.data.TIMELINE_ACTIVITY_VALUES && res.data.TIMELINE_ACTIVITY_VALUES.listItems;
      this.blockingListValues = res.data.BLOCKING_ACTIVITY_LIST.listItems
      this.filterStatusData = res.data;
      if (sorted) {
        this.filterStatusData = sorted.map(x => {
          return { itemId: x.itemId, value: x.value };
        });
      }

      let jobApplicationListValues: any[] = []
      jobApplicationListValues = res.data.JOB_APPLICATION_ACTIVITY.listItems
      if (Array.isArray(jobApplicationListValues) && jobApplicationListValues.length > 0) {
        let recentActivity: any;
        let recentActivityOrder: any;
        if (this.jeas) {
          recentActivity = this.jeas[0]
        }

        if (recentActivity) {
          recentActivityOrder = jobApplicationListValues.find(ele => ele.itemId === recentActivity.activityType)
        }

        if (recentActivityOrder) {
          this.jobApplicationFutureListValues = []
          jobApplicationListValues.forEach(ele => {
            if (ele.order > recentActivityOrder.order) {
              this.jobApplicationFutureListValues.push(ele);
            }
          })
        }

        const filteredData: any = [];
        const encounteredData = new Set<number>();

        for (const item of this.jobApplicationFutureListValues) {
          if (!encounteredData.has(item.order)) {
            filteredData.push(item);
            encounteredData.add(item.order);
          }
        }

        this.jobApplicationListValues = filteredData.map(x => {
          return { itemId: x.itemId, value: x.value, item: x.item, order: x.order }
        })

        // Process events to set notion (positive/negative/progress)
        for (const item of this.jeas) {
          const exists = this.blockingListValues.find((listItem) => (listItem.itemId === item.activityType));
          if (exists) {
            item.notion = "negative"
          } else {
            item.notion = "positive"
          }
        }

        if (this.jeas[0] && this.jeas[0].activityType == "ONBOARDED") {
          this.jeas[0].notion = "positive"
          this.activityEnded = true
        } else {
          if (this.jeas[0] && this.jeas[0].notion != "negative") {
            this.jeas[0].notion = "progress"
            this.activityEnded = false
          } else if (this.jeas[0] && this.jeas[0].notion == "negative") {
            this.activityEnded = true
          }
        }
      }

      // Process timeline stages for row-design view (stores timelineStages in JobData)
      if (this.JobData) {
        this.JobData.timelineEvents = this.jeas; // Store timeline events in JobData
        this.processTimelineForJob(this.JobData);
      }

      // Now process the timeline data for horizontal display (medium view)
      this.processTimelineForHorizontalDisplay();
    });
  }
  
  processTimelineForHorizontalDisplay() {
    this.mergedTimelineData = [];
    
    // Process existing timeline events (reverse order since jeas comes newest first)
    const reversedJeas = [...this.jeas].reverse();
    reversedJeas.forEach((event, index) => {
      this.mergedTimelineData.push({
        title: this.getJobTimelineFilterValue(event.activityType) || event.activityType,
        createdOn: event.createdOn,
        notion: event.notion,
        showIcon: true,
        showDate: true,
        showNumber: false,
        order: index
      });
    });
    
    // Check if the most recent activity (first in jeas array) has negative notion
    const hasNegativeNotion = this.jeas.length > 0 && this.jeas[0].notion === "negative";
    
    // Only add future activities if the current notion is not negative
    if (!hasNegativeNotion) {
      const sortedFutureActivities = [...this.jobApplicationListValues].sort((a, b) => a.order - b.order);
      sortedFutureActivities.forEach((futureActivity, index) => {
        this.mergedTimelineData.push({
          title: futureActivity.value || futureActivity.item,
          notion: "future",
          showIcon: false,
          showDate: false,
          showNumber: true,
          order: reversedJeas.length + index
        });
      });
    }
    
    console.log('Processed timeline data:', this.mergedTimelineData, 'Has negative notion:', hasNegativeNotion);

    // Call timeline grouping method
    this.groupTimelineData();

    this.timelineIsLoading = false;
  }

  // Timeline grouping property
  groupedTimelineData: any = {
    submitted: [],
    shortlisted: [],
    interview: [],
    selected: [],
    offered: [],
    onboarded: []
  };

  // Group timeline data into categories
  groupTimelineData() {
    // Reset grouped data
    this.groupedTimelineData = {
      submitted: [],
      shortlisted: [],
      interview: [],
      selected: [],
      offered: [],
      onboarded: []
    };

    // Group each timeline entry by title
    this.mergedTimelineData.forEach(entry => {
      const title = entry.title.toLowerCase();

      // Submitted category
      if (title.includes('submitted') || title.includes('applied')) {
        this.groupedTimelineData.submitted.push(entry);
      }
      // Shortlisted category
      else if (title.includes('shortlisted')) {
        this.groupedTimelineData.shortlisted.push(entry);
      }
      // Interview category
      else if (title.includes('interview')) {
        this.groupedTimelineData.interview.push(entry);
      }
      // Selected category
      else if (title.includes('selected')) {
        this.groupedTimelineData.selected.push(entry);
      }
      // Offered category
      else if (title.includes('offered') || title.includes('offer')) {
        this.groupedTimelineData.offered.push(entry);
      }
      // Onboarded category
      else if (title.includes('onboarded') || title.includes('pre-onboarded')) {
        this.groupedTimelineData.onboarded.push(entry);
      }
    });

    console.log('Grouped timeline data:', this.groupedTimelineData);
  }

  getJobTimelineFilterValue(key: string) {
    if (Array.isArray(this.filterStatusData)) {
      const arrs: Array<any> = [...this.filterStatusData];
      if (arrs) {
        const find = arrs.find(c => c.itemId === key);
        return find ? find.value : null;
      }
    }
    return null;
  }

  // ============================================================
  // TIMELINE STAGES PROCESSING METHODS (Copied from candidate-card for row-design view)
  // ============================================================

  // Process timeline events for a job - builds timelineStages
  processTimelineForJob(job: any) {
    if (!job.timelineEvents || job.timelineEvents.length === 0) {
      job.timelineDates = {};
      job.mergedTimelineData = [];
      job.timelineStages = this.getDefaultTimelineStages();
      return;
    }

    console.log('🔍 [JobCard] Processing timeline for job:', job.jobId);
    console.log('📋 Raw timeline events:', job.timelineEvents);
    console.log('📋 Job application order list:', this.jobApplicationListValues);

    // STEP 1: Order all timeline events based on the JOB_APPLICATION_ACTIVITY order from API
    const orderedEvents = this.orderTimelineEventsByAPI(job.timelineEvents);
    console.log('✅ Ordered events:', orderedEvents);

    // STEP 2: Group events into stages and identify rejection points
    const groupedStages = this.groupEventsIntoStages(orderedEvents);
    console.log('✅ Grouped stages:', groupedStages);

    // STEP 3: Build timeline stages with rejection handling
    job.timelineStages = this.buildTimelineStagesFromGroupedEvents(groupedStages);
    console.log('✅ Final timeline stages:', job.timelineStages);

    // Set legacy date properties for backward compatibility
    job.timelineDates = {};
    job.timelineStages.forEach((stage: any) => {
      if (stage.date) {
        job.timelineDates[stage.id] = stage.date;
      }
    });

    console.log('🎯 Timeline processing complete for:', job.jobId);
  }

  // STEP 1: Order timeline events by JOB_APPLICATION_ACTIVITY API order
  orderTimelineEventsByAPI(events: any[]): any[] {
    if (!this.jobApplicationListValues || this.jobApplicationListValues.length === 0) {
      console.warn('⚠️ No jobApplicationListValues available, returning events as-is');
      return events;
    }

    // Create a map of activityType -> order
    const orderMap = new Map<string, number>();
    this.jobApplicationListValues.forEach((item: any) => {
      if (item.itemId && item.order !== undefined && item.order !== null) {
        orderMap.set(item.itemId, item.order);
      }
    });

    console.log('📊 Order map:', Array.from(orderMap.entries()));

    // Sort events by order
    const orderedEvents = events.sort((a, b) => {
      const orderA = orderMap.get(a.activityType) ?? 999;
      const orderB = orderMap.get(b.activityType) ?? 999;
      return orderA - orderB;
    });

    return orderedEvents;
  }

  // STEP 2: Group events into stages (Applied, Shortlisted, Interview, Selected, Offered, Onboarded)
  groupEventsIntoStages(orderedEvents: any[]): any {
    const stageMapping = {
      'APPLIED': {
        id: 'APPLIED',
        label: 'Applied',
        activityTypes: ['JOB-APPLIED', 'APPLIED']
      },
      'SHORTLISTED': {
        id: 'SHORTLISTED',
        label: 'Shortlisted',
        activityTypes: ['CANDIDATE-SHORTLISTED', 'SHORTLISTED']
      },
      'INTERVIEW': {
        id: 'INTERVIEW',
        label: 'Interview',
        activityTypes: ['INTERVIEW-SCHEDULED', 'INTERVIEW-ACCEPTED', 'INTERVIEW-REJECTED', 'INTERVIEW SCHEDULED', 'L1-INTERVIEW', 'L2-INTERVIEW', 'L3-INTERVIEW']
      },
      'SELECTED': {
        id: 'SELECTED',
        label: 'Selected',
        activityTypes: ['CANDIDATE-SELECTED', 'SELECTED']
      },
      'OFFERED': {
        id: 'OFFERED',
        label: 'Offered',
        activityTypes: ['OFFERED', 'OFFER-ACCEPTED', 'OFFER-DECLINED', 'OFFER-WITHDRAWN']
      },
      'ONBOARDED': {
        id: 'ONBOARDED',
        label: 'Onboarded',
        activityTypes: ['ONBOARDED', 'PREONBOARDED', 'PRE-ONBOARDED']
      }
    };

    // Build reverse lookup: activityType -> stageId
    const activityToStage = new Map<string, string>();
    Object.entries(stageMapping).forEach(([stageId, config]: any) => {
      config.activityTypes.forEach((activityType: string) => {
        activityToStage.set(activityType, stageId);
      });
    });

    // Group events by stage
    const grouped: any = {
      APPLIED: { events: [], hasRejection: false, latestEvent: null },
      SHORTLISTED: { events: [], hasRejection: false, latestEvent: null },
      INTERVIEW: { events: [], hasRejection: false, latestEvent: null },
      SELECTED: { events: [], hasRejection: false, latestEvent: null },
      OFFERED: { events: [], hasRejection: false, latestEvent: null },
      ONBOARDED: { events: [], hasRejection: false, latestEvent: null }
    };

    orderedEvents.forEach((event: any) => {
      const stageId = activityToStage.get(event.activityType);

      if (stageId && grouped[stageId]) {
        grouped[stageId].events.push(event);

        // Check if this is a rejection event
        const isRejection = this.isNegativeStatus(event.activityType);
        if (isRejection) {
          grouped[stageId].hasRejection = true;
          console.log(`🚨 Rejection detected: ${event.activityType} in stage ${stageId}`);
        }

        // Track the latest event (most recent by order/date)
        if (!grouped[stageId].latestEvent) {
          grouped[stageId].latestEvent = event;
        } else {
          // Compare by date if same stage has multiple events
          const currentDate = new Date(event.createdOn).getTime();
          const latestDate = new Date(grouped[stageId].latestEvent.createdOn).getTime();
          if (currentDate > latestDate) {
            grouped[stageId].latestEvent = event;
          }
        }

        console.log(`  ✓ Event ${event.activityType} → ${stageId} (rejection: ${isRejection})`);
      } else {
        console.warn('⚠️ Unknown activity type:', event.activityType);
      }
    });

    return grouped;
  }

  // STEP 3: Build timeline stages from grouped events with rejection handling
  buildTimelineStagesFromGroupedEvents(groupedStages: any): any[] {
    const stageOrder = ['APPLIED', 'SHORTLISTED', 'INTERVIEW', 'SELECTED', 'OFFERED', 'ONBOARDED'];
    const stages: any[] = [];

    let rejectionFound = false;
    let hasAnyRejection = false;

    // First pass: Check if there's ANY rejection in the timeline
    for (let i = 0; i < stageOrder.length; i++) {
      const stageData = groupedStages[stageOrder[i]];
      if (stageData.hasRejection) {
        hasAnyRejection = true;
        break;
      }
    }

    console.log(`🔍 Has any rejection in timeline: ${hasAnyRejection}`);

    // Build stages in order
    for (let i = 0; i < stageOrder.length; i++) {
      const stageId = stageOrder[i];
      const stageData = groupedStages[stageId];

      // If rejection already found, STOP - don't add any more stages
      if (rejectionFound) {
        console.log(`🛑 Skipping stage ${stageId} - rejection already found, timeline ends`);
        break;
      }

      // Determine label
      const labelMap: any = {
        'APPLIED': 'Applied',
        'SHORTLISTED': 'Shortlisted',
        'INTERVIEW': 'Interview',
        'SELECTED': 'Selected',
        'OFFERED': 'Offered',
        'ONBOARDED': 'Onboarded'
      };

      const hasEvents = stageData.events.length > 0;
      const latestEvent = stageData.latestEvent;
      const baseLabel = labelMap[stageId] || stageId;

      // LOGIC: If rejection exists anywhere, skip empty stages
      //        If no rejection exists, show ALL stages (completed + future)
      if (!hasEvents && hasAnyRejection) {
        console.log(`⏭️ Skipping empty stage ${stageId} (rejection exists in timeline)`);
        continue;
      }

      // Determine if this is a rejection
      const isNegative = latestEvent ? this.isNegativeStatus(latestEvent.activityType) : false;

      // For rejected events, show the specific rejection name
      // For normal events, use the stage label
      let displayLabel = baseLabel;
      if (isNegative && latestEvent) {
        const eventName = this.getJobTimelineFilterValue(latestEvent.activityType);
        displayLabel = eventName || latestEvent.activityType || baseLabel;
      }

      console.log(`✅ Stage ${stageId}: hasEvents=${hasEvents}, isNegative=${isNegative}, displayLabel=${displayLabel}`);

      // Create stage object
      const stage: any = {
        id: stageId,
        label: displayLabel,
        baseLabel: baseLabel,
        date: latestEvent ? new Date(latestEvent.createdOn) : null,
        completed: hasEvents,
        active: false,
        notion: hasEvents ? 'default' : 'future',
        isNegative: isNegative,
        isTerminal: false,
        activityType: latestEvent?.activityType,
        events: stageData.events
      };

      // Determine notion based on latest event (for completed stages)
      if (latestEvent) {
        stage.notion = this.determineNotion(latestEvent.activityType);
      }

      // If this stage has a rejection, mark it as terminal and STOP
      if (isNegative) {
        rejectionFound = true;
        stage.isTerminal = true;
        stage.active = true;
        console.log(`🛑 REJECTION at stage: ${stageId} (${displayLabel}) - STOPPING HERE`);
        stages.push(stage);
        break;
      }

      // Add stage to timeline
      stages.push(stage);
    }

    // NEW LOGIC: Fill in skipped stages up to highest completed
    let highestCompletedIndex = -1;

    // Find the highest completed stage (with actual events)
    for (let i = stages.length - 1; i >= 0; i--) {
      if (stages[i].completed && !stages[i].isNegative && !rejectionFound) {
        highestCompletedIndex = i;
        break;
      }
    }

    console.log(`🔍 Highest completed stage index: ${highestCompletedIndex}`);

    // Mark all stages up to the highest as completed (fill in gaps for skipped stages)
    if (highestCompletedIndex >= 0 && !rejectionFound) {
      for (let i = 0; i <= highestCompletedIndex; i++) {
        if (!stages[i].isNegative) {
          // Store whether this was an actual event or implied
          const wasActuallyCompleted = stages[i].completed;

          stages[i].completed = true;
          stages[i].notion = 'default';

          // Mark as implied if it didn't have actual events (skipped stage)
          if (!wasActuallyCompleted) {
            stages[i].isImplied = true;

            // Find the next actually completed stage and copy its date
            let nextActualDate = null;
            for (let j = i + 1; j <= highestCompletedIndex; j++) {
              if (!stages[j].isImplied && stages[j].date) {
                nextActualDate = stages[j].date;
                break;
              }
            }

            // Set the date to the next actual completion date
            if (nextActualDate) {
              stages[i].date = nextActualDate;
              console.log(`✨ Stage ${stages[i].id} marked as implied completion (skipped) with date from next actual stage`);
            } else {
              console.log(`✨ Stage ${stages[i].id} marked as implied completion (skipped) - no date available`);
            }
          }
        }
      }

      // Mark the highest completed stage as active
      stages[highestCompletedIndex].active = true;
      console.log(`✅ Stage ${stages[highestCompletedIndex].id} marked as active (highest)`);
    }

    // If rejection found, it's already marked as active in the rejection logic above
    if (rejectionFound) {
      console.log(`🛑 Rejection found - timeline ends at rejection point`);
    }

    console.log('🎯 Final timeline:', stages.map(s => `${s.id}(${s.label}, completed:${s.completed}, implied:${s.isImplied || false}, negative:${s.isNegative})`));
    return stages;
  }

  // Get default timeline stages when no events exist
  getDefaultTimelineStages() {
    return [
      { id: 'APPLIED', label: 'Applied', date: null, completed: false, active: false, notion: 'default', isNegative: false, isTerminal: false },
      { id: 'SHORTLISTED', label: 'Shortlisted', date: null, completed: false, active: false, notion: 'progress', isNegative: false, isTerminal: false },
      { id: 'INTERVIEW', label: 'Interview', date: null, completed: false, active: false, notion: 'progress', isNegative: false, isTerminal: false },
      { id: 'SELECTED', label: 'Selected', date: null, completed: false, active: false, notion: 'positive', isNegative: false, isTerminal: false },
      { id: 'OFFERED', label: 'Offered', date: null, completed: false, active: false, notion: 'positive', isNegative: false, isTerminal: false },
      { id: 'ONBOARDED', label: 'Onboarded', date: null, completed: false, active: false, notion: 'positive', isNegative: false, isTerminal: false }
    ];
  }

  // Determine notion based on activity type
  determineNotion(activityType: string): string {
    const negativeStatuses = [
      'REJECTED',
      'INTERVIEW-REJECTED',
      'OFFER-DECLINED',
      'OFFER-WITHDRAWN',
      'CANDIDATE-REJECTED',
      'APPLICATION-REJECTED'
    ];
    const progressStatuses = [
      'CANDIDATE-SHORTLISTED',
      'SHORTLISTED',
      'INTERVIEW-SCHEDULED',
      'INTERVIEW-ACCEPTED',
      'INTERVIEW SCHEDULED'
    ];
    const positiveStatuses = [
      'CANDIDATE-SELECTED',
      'SELECTED',
      'OFFERED',
      'OFFER-ACCEPTED',
      'ONBOARDED',
      'PREONBOARDED',
      'PRE-ONBOARDED'
    ];

    if (negativeStatuses.some(neg => activityType.includes(neg) || neg.includes(activityType))) return 'negative';
    if (progressStatuses.includes(activityType)) return 'progress';
    if (positiveStatuses.includes(activityType)) return 'positive';
    return 'default';
  }

  // Check if status is negative (rejection)
  isNegativeStatus(activityType: string): boolean {
    const negativeKeywords = [
      'REJECTED',
      'REJECT',
      'DECLINED',
      'DECLINE',
      'WITHDRAWN',
      'WITHDRAW'
    ];

    // Check if activityType contains any negative keyword
    return negativeKeywords.some(keyword =>
      activityType.toUpperCase().includes(keyword)
    );
  }

  showDocumentSection: boolean =false;

  typeOfDocuments = [
    {name: 'Resume', mandatory: false, isUploaded: true, 
      documents:[
        // {name: 'New Resume',lastUpdated: '28/09/2025',validFrom : '', expiry:'', status: 'Verified', attachment:''},
      ]
    },
    {name: 'Drivers License', mandatory: false, isUploaded: true, 
      documents:[
        // {name: 'License',lastUpdated: '28/09/2025',validFrom : '25/08/2003', expiry:'16/08/2023', status: 'Expired', attachment:''},
        // {name: 'License',lastUpdated: '28/09/2025',validFrom : '13/04/2024', expiry:'19/12/2035', status: 'Pending Verification', attachment:''},
      ]
    },
    {name: 'Employment Authorization Document', mandatory: false, isUploaded: true,documents:[]},
    {name: 'Passport', mandatory: false, isUploaded: true,documents:[]},
    {name: 'Visa', mandatory: false, isUploaded: true,documents:[]},
    {name: 'I-94', mandatory: false, isUploaded: true,documents:[]},
    {name: 'Background Check Certification', mandatory: false, isUploaded: true,documents:[]},
    {name: 'Background Verification', mandatory: false, isUploaded: true,documents:[]},
    {name: 'Drug Screening', mandatory: false, isUploaded: true,documents:[]}
  ]
  
  openDocuments() {
    // Clear any documents from a previous open BEFORE fetching this card's
    // config. getSavedRequiredDocuments() repopulates `typeOfDocuments` in
    // place and bails via `if (!config) return` when there's no saved config,
    // so without this reset the slider could surface stale rows that don't
    // belong to the current open.
    this.resetTypeOfDocuments();
    this.getSavedRequiredDocuments('open');

  }

  /** Blank out the shared document buckets + header count so the slider
   *  starts clean each time it is opened. */
  resetTypeOfDocuments() {
    for (const doc of this.typeOfDocuments) {
      doc.mandatory = false;
      doc.documents = [];
    }
    this.totalMandatoryDocuments = 0;
  }

  closeDocuments() {
    this.showDocumentSection = false;
  }

  saveDocuments() {
    this.showDocumentSection = false;
  }

  refreshDocumentData() {
    // Call existing method to fetch fresh data
    this.getSavedRequiredDocuments('refresh');
  }

  totalMandatoryDocuments:any;
  getSavedRequiredDocuments(from:any) {
    // Don't make the API call if we don't have both jobId and candidateId
    if (!this.JobData?.jobId || !this.candidateData?.candidateId) {
      console.warn('[JobCard] getSavedRequiredDocuments - Missing jobId or candidateId', {
        jobId: this.JobData?.jobId,
        candidateId: this.candidateData?.candidateId,
        from: from
      });
      return;
    }

    let payload = {
      jobId: this.JobData.jobId,
      candidateId: this.candidateData.candidateId
    };

    this.util.startLoader();
    this.api.create('jobs/getContractDocumentDetails', payload)
      .pipe(finalize(() => this.util.stopLoader()))
      .subscribe({
        next: (res: any) => {
          console.log('details , ', res);
          const config = res.data?.existingConfig;
          // Return early if config is not available
          if (!config) {
            if (from === 'open') {
              Swal.fire('The requestor has not initiated document collection process. You will be notified once it is initiated.','','info');
            }
            return;
          }

          if(from === 'open' && !this.showDocumentSection){
            this.showDocumentSection = true;
          }

          // Map API response to typeOfDocuments
          for (let doc of this.typeOfDocuments) {
            switch (doc.name) {
              case 'Resume':
                doc.mandatory = config.resumeMandatory;
                doc.documents = config?.resumeDocuments || [];
                break;
              case 'Drivers License':
                doc.mandatory = config.driversLicenseMandatory;
                doc.documents = config?.driversLicenseDocuments || [];
                break;
              case 'Employment Authorization Document':
                doc.mandatory = config.employmentAuthorizationMandatory;
                doc.documents = config?.employmentAuthorizationDocuments || [];
                break;
              case 'Passport':
                doc.mandatory = config.passportMandatory;
                doc.documents = config?.passportDocuments || [];
                break;
              case 'Visa':
                doc.mandatory = config.visaMandatory;
                doc.documents = config?.visaDocuments || [];
                break;
              case 'I-94':
                doc.mandatory = config.i94Mandatory;
                doc.documents = config?.i94Documents || [];
                break;
              case 'Background Verification':
                doc.mandatory = config.backgroundCheckstatusMandatory;
                doc.documents = config?.backgroundCheckDocuments || [];
                break;
              case 'Background Check Certification':
                doc.mandatory = config.backgroundCheckCertificateMandatory;
                doc.documents = config?.backgroundCheckCertificationDocuments || [];
                break;
              case 'Drug Screening':
                doc.mandatory = config.drugScreenMandatory;
                doc.documents = config?.drugScreenDocuments || [];
                break;
            }
          }
          // ✅ Count how many documents are mandatory
          // this.totalMandatoryDocuments = this.typeOfDocuments.filter(d => d.mandatory).length;
          this.totalMandatoryDocuments = res?.data.documentProgress.pendingUpload ?? 0;

          console.log('Updated typeOfDocuments :: ', this.typeOfDocuments);
        },
        error: (err: any) => {
          console.error('Error fetching document details', err);
        }
      });
  }

  // Toggle skills visibility - handles both row-design and v2 large view
  toggleSkills(item?: any): void {
    if (item) {
      // For row-design view
      item.showAllSkills = !item.showAllSkills;
    } else {
      // For v2 large view
      this.skillsExpanded = !this.skillsExpanded;
    }
  }  

  reasons: any[] = [];
  candidateScore:any;
  private retryAttempt: number = 0;

  showDetails(item:any, modal:any){
    console.log('item: ', item);
    let payload = {
      sourceEntityId : this.JobData.jobId,
      targetEntityId : item.candidateId,
      type : 'JOB',
      groupType : 'APPLICANT_JOB'
    }
    this.util.startLoader();
    this.reasons = [];
    this.candidateScore = null;
    this.retryAttempt = 0;

    // Use the new retry method with progress indication
    this.api.fetchRankingDetailsWithRetry(payload, 3, 2500).subscribe({
      next: (res) => {
        if(res.code == '00000'){
          let ranking = res.data.ranking;

          if(ranking){
            // Build reasons array from the ranking object
            this.reasons = [{
              targetEntityId: ranking.targetEntityId,
              score: ranking.score,
              reason: ranking.reason,
              strengths: ranking.strengths || [],
              weaknesses: ranking.weaknesses || [],
              updatedOn: ranking.updatedOn
            }];

            this.candidateScore = ranking.score + '%';
            this.util.stopLoader();
            this.openModal(modal);
          }else {
            this.util.stopLoader();
            Swal.fire('No ranking details available','','info');
          }
        }else {
          this.util.stopLoader();
          Swal.fire('Something went wrong','','error');
        }
      },
      error: (err) => {
        this.util.stopLoader();

        // Handle processing timeout
        if (err.timeout && err.isProcessing) {
          Swal.fire({
            title: 'Analysis In Progress',
            text: err.message || 'The AI analysis is taking longer than expected. Please try again in a moment.',
            icon: 'warning',
            confirmButtonText: 'OK'
          });
        } else if (err.isProcessing) {
          // Retry in progress - show loading message
          this.retryAttempt++;
          Swal.fire({
            title: 'Analyzing Match...',
            html: `AI is analyzing candidate compatibility.<br><small>Attempt ${this.retryAttempt}/3</small>`,
            icon: 'info',
            timer: 2500,
            timerProgressBar: true,
            showConfirmButton: false,
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
            }
          });
        } else {
          // Other errors
          Swal.fire('Something went wrong','','error');
        }
      }
    });
  }

  openModal(modalName: any){
    try {
      this.ngbModalService.open(modalName, {size: 'md', centered: true}).result.then((result) => {
        console.log('Modal closed with result:', result);
      }, (reason) => {
        console.log('Modal dismissed with reason:', reason);
      });
    } catch (error) {
      console.error('Error opening modal:', error);
      Swal.fire('Error', 'Failed to open modal', 'error');
    }
  }

  closeModal(){
    this.ngbModalService.dismissAll();
  }  

  showPercentageDetails: boolean = false;
  details:any;
  openPercentageDetails(item:any){
    this.showPercentageDetails = true;
    this.details = item;
  }

  closePercentageDetails(){
    this.showPercentageDetails= false;
    this.details = null;
  }


  getAllSkills(JobData: any): string[] {
    const primary = JobData?.primarySkills || [];
    const secondary = JobData?.secondarySkills || [];
    return [...primary, ...secondary]; // merge both arrays
  }

  /**
   * Resolve the numeric match % for this job card, regardless of which field
   * the backend ships. `jobs/findAppliedJobs` returns it as `matchingScore`
   * OR `matchScore`; marketplace (`pageFrom === 'suggestedJobs'`) returns
   * `score`. Returns `null` when no usable value exists (0 included) so the
   * badge template can hide itself with a single `!= null` check.
   * Mirrors `dashboard-mappers.ts:mapSpotlightJob` fallback order so both
   * surfaces stay in sync if the backend changes.
   */
  getJobMatchScore(): number | null {
    if (!this.JobData) return null;
    const isMarketplace = this.pageFrom === 'suggestedJobs';
    const raw = isMarketplace
      ? (this.JobData.score ?? this.JobData.matchScore ?? null)
      : (this.JobData.matchingScore ?? this.JobData.matchScore ?? this.JobData.score ?? null);
    const n = Number(raw);
    if (raw == null || isNaN(n) || n === 0) return null;
    return n;
  }

  // Match colour tier by score: green >=75, amber 40-74, red <40 (empty when no
  // score). Mirrors .jc-v3-c-match-badge{,.amber,.red} in job-center-v3.scss.
  jobMatchTier(): string {
    const score = this.getJobMatchScore();
    if (score == null) return '';
    if (score >= 75) return 'green';
    if (score >= 40) return 'amber';
    return 'red';
  }

  getBorderRadius(value: string): string {
    return value?.length < 50 ? '999px' : '20px';
  }

  /**
   * Dynamically loads CandidatesPageComponent to break circular dependency
   * Called after modal is opened and template is rendered
   */
  async loadCandidatesPageComponent(retryCount: number = 0) {
    const maxRetries = 5;

    // If container hasn't been found yet, try to get it from the modal's DOM
    if (!this.candidatesPageContainer) {
      if (retryCount < maxRetries) {
        // Try to find the container element in the modal's DOM
        const containerElement = document.getElementById('candidatesPageDynamicContainerJobCard');

        if (!containerElement) {
          const delay = 50 * Math.pow(2, retryCount); // 50ms, 100ms, 200ms, 400ms, 800ms
          console.log(`[JobCard] CandidatesPageContainer not ready, retrying in ${delay}ms (attempt ${retryCount + 1}/${maxRetries})`);
          setTimeout(() => this.loadCandidatesPageComponent(retryCount + 1), delay);
          return;
        }
      } else {
        console.error('[JobCard] CandidatesPageContainer not available after maximum retries');
        return;
      }
    }

    console.log('[JobCard] Proceeding with dynamic component load...');

    try {
      console.log('[JobCard] Loading CandidatesPageComponent dynamically...');

      // Dynamic import to break circular dependency
      const { CandidatesPageComponent } = await import('../../candidate-module/candidates-page/candidates-page.component');

      // Get the container element
      const containerElement = document.getElementById('candidatesPageDynamicContainerJobCard');

      if (containerElement) {
        // Clear previous content
        containerElement.innerHTML = '';

        // Use ApplicationRef to create and attach the component
        const componentFactory = this.injector.get(ComponentFactoryResolver);
        const factory = componentFactory.resolveComponentFactory(CandidatesPageComponent);

        // Create the component
        this.candidatesPageComponentRef = factory.create(this.injector);

        // Set inputs (maintaining all @Input decorators from original template)
        this.candidatesPageComponentRef.instance.viewSize = 'extra-small';
        this.candidatesPageComponentRef.instance.passValues = this.applyResponse;
        this.candidatesPageComponentRef.instance.jobData = this.JobData;
        this.candidatesPageComponentRef.instance.fromApply = true;
        this.candidatesPageComponentRef.instance.candidatesFoundStatus = this.candidateFoundStatus;

        // Subscribe to outputs (maintaining all @Output decorators)
        this.candidatesPageComponentRef.instance.selectedCandidate.subscribe((data: any) => {
          this.getchildData(data);
        });

        // Attach the component's host view to the application
        const appRef = this.injector.get(ApplicationRef);
        appRef.attachView(this.candidatesPageComponentRef.hostView);

        // Append the component's DOM element to our container
        const domElem = (this.candidatesPageComponentRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;
        containerElement.appendChild(domElem);

        // Trigger change detection
        this.candidatesPageComponentRef.changeDetectorRef.detectChanges();

        console.log('[JobCard] CandidatesPageComponent loaded successfully');
      } else {
        console.error('[JobCard] Container element not found in DOM');
      }
    } catch (error) {
      console.error('[JobCard] Error loading CandidatesPageComponent:', error);
    }
  }



  // Maps the job-applied currentStatus to a dot index in the 6-stage pipeline
  // Applied → Shortlisted → Interview → Selected → Offered → Onboarded.
  // Mirrors candidate-card-table-view.component.ts:getStageIndex().
  //
  // AUDIT_04 Batch 4 — returns -1 for REJECTED / INTERVIEW-REJECTED /
  // OFFER-DECLINED / OFFER-WITHDRAWN / PROFILE-REJECTED so the template
  // won't falsely mark "Applied — current" for a rejected application.
  // Paired with `isRejectedStatus()` + `.negative` track/label styling +
  // a terminal badge surfaced in the template.
  getStageIndex(status: string): number {
    if (!status) return -1;
    if (this.isRejectedStatus(status)) return -1;
    const stages = ['JOB-APPLIED', 'CANDIDATE-SHORTLISTED', 'INTERVIEW-SCHEDULED', 'CANDIDATE-SELECTED', 'OFFERED', 'ONBOARDED'];
    const idx = stages.findIndex(s => status?.toUpperCase()?.includes(s.split('-')[0]));
    return idx >= 0 ? idx : -1;
  }

  isRejectedStatus(status: string): boolean {
    if (!status) return false;
    const s = status.toUpperCase();
    return s === 'REJECTED'
        || s === 'INTERVIEW-REJECTED'
        || s === 'INTERVIEW-FAILED'
        || s === 'OFFER-DECLINED'
        || s === 'OFFER-WITHDRAWN'
        || s === 'PROFILE-REJECTED'
        || s === 'CANDIDATE-WITHDRAWN';
  }
  // `getStageLabel()` already defined at line 386 — existing labelMap covers
  // every negative status used by `isRejectedStatus()`, so reuse as-is.

  timelineDataGrouped:any;
  positiveStages = ['CANDIDATE_SUBMITTED','CANDIDATE-SHORTLISTED','INTERVIEW-SCHEDULED','INTERVIEW-ACCEPTED','CANDIDATE-SELECTED','OFFERED','OFFER-ACCEPTED','PRE-ONBOARDED','ONBOARDED'];
  negativeStages = ['REJECTED','PROFILE-REJECTED','INTERVIEW-REJECTED','INTERVIEW-FAILED','OFFER-DECLINED','CANDIDATE-WITHDRAWN','OFFER-WITHDRAWN'];
  timelineStatusLabelMap: Record<string, string> = {
    'REJECTED': 'Rejected',
    'PROFILE-REJECTED': 'Profile Rejected',
    'INTERVIEW-REJECTED': 'Interview Rejected',
    'INTERVIEW-FAILED': 'Interview Failed',
    'OFFER-DECLINED': 'Offer Declined',
    'CANDIDATE-WITHDRAWN': 'Candidate Withdrawn',
    'OFFER-WITHDRAWN': 'Offer Withdrawn'
  };

  isTimelineLoading = false;
  defaultTimelineSkeleton = this.getDefaultTimelineStagesEnhanced(); // reuse your existing method

  async prepareTimeline(){
    this.isTimelineLoading = true;
    // Seed with the default (all-future) timeline so the V3 jc-v3-row
    // renders the placeholder immediately while the API is in flight;
    // the API success path replaces this with the real grouped timeline.
    // (V2 row-design still gates on `isTimelineLoading` for its skeleton,
    // so this seed only surfaces in V3 where the skeleton was removed.)
    this.timelineDataGrouped = this.getDefaultTimelineStagesEnhanced();
    this.api.create("jobs/findTimeLines", this.payload).subscribe(res => {
      console.log('Timeline API response:', res);
      if (res && res.code === "00000" && res.data) {
        let timelines = res.data?.timeLines || [];
        if (timelines.length > 0) {
          timelines = timelines.reverse();

          let defaultTimeline = this.getDefaultTimelineStagesEnhanced();
          let lastCompletedIndex = 0;

          for (let i = 0; i < timelines.length; i++) {
            let t = timelines[i];

            // 🔴 NEGATIVE STATUS
            if (this.negativeStages.includes(t.activityType)) {
              let targetIndex = Math.min(lastCompletedIndex + 1, defaultTimeline.length - 1);
              let stag = defaultTimeline[targetIndex];
              stag.negative = true;
              stag.future = false;
              stag.completed = true;
              stag.label = this.timelineStatusLabelMap[t.activityType];
              stag.date = t.createdOn;
              break;
            }

            // ✅ POSITIVE / NORMAL STATUS
            let stage = defaultTimeline.find(d => d.relatedStatuses.includes(t.activityType));
            if (!stage) continue;

            stage.completed = true;
            stage.future = false;
            stage.date = t.createdOn;
            stage.negative = false; 
            lastCompletedIndex = stage.index;
            
            // 👉 IMPLIED PRIOR STAGES
            for (let j = 0; j < stage.index; j++) {
              let isNotCompletedStage = defaultTimeline[j]; 
              if (isNotCompletedStage && !isNotCompletedStage.completed) {
                isNotCompletedStage.completed = true;
                isNotCompletedStage.future = false;
                isNotCompletedStage.date = t.createdOn;
                isNotCompletedStage.negative = false; 
                isNotCompletedStage.isImplied = true;
              }
            }
          }
          this.isTimelineLoading = false;
          this.timelineDataGrouped = defaultTimeline;
        }
      }
    }, err => {
      console.error('Timeline API error:', err);
    });
  }


  // Mirrors candidate-card-table-view's helper. Walks back to the latest
  // completed stage (positive OR negative) and returns the % of the
  // track width the purple line should span. Negative stage keeps its
  // red dot/label/date via the `.negative` class — only the line is
  // unified purple. With 6 stages distributed via flex:1, dot N sits at
  // (2N+1)/12 of the track; span from dot 0 to dot N is N/stages.length.
  getProgressLinePct(stages: any[]): number {
    if (!stages?.length) return 0;
    let idx = 0;
    for (let i = stages.length - 1; i >= 0; i--) {
      if (stages[i].completed) { idx = i; break; }
    }
    return (idx / stages.length) * 100;
  }

  getDefaultTimelineStagesEnhanced() {
    return [
      { index: 0, id: 'APPLIED',     label: 'Applied',     date: null, completed: false, negative: false, future: true, isImplied: false, relatedStatuses: ['CANDIDATE_SUBMITTED'] },
      { index: 1, id: 'SHORTLISTED', label: 'Shortlisted', date: null, completed: false, negative: false, future: true, isImplied: false, relatedStatuses: ['CANDIDATE-SHORTLISTED'] },
      { index: 2, id: 'INTERVIEW',   label: 'Interview',   date: null, completed: false, negative: false, future: true, isImplied: false, relatedStatuses: ['INTERVIEW-SCHEDULED', 'INTERVIEW-ACCEPTED', 'L1-INTERVIEW', 'L2-INTERVIEW', 'L3-INTERVIEW'] },
      { index: 3, id: 'SELECTED',    label: 'Selected',    date: null, completed: false, negative: false, future: true, isImplied: false, relatedStatuses: ['CANDIDATE-SELECTED'] },
      { index: 4, id: 'OFFERED',     label: 'Offered',     date: null, completed: false, negative: false, future: true, isImplied: false, relatedStatuses: ['OFFERED', 'OFFER-ACCEPTED'] },
      { index: 5, id: 'ONBOARDED',   label: 'Onboarded',   date: null, completed: false, negative: false, future: true, isImplied: false, relatedStatuses: ['ONBOARDED'] }
    ];
  }


}

